/**
 * web.init.js — GUARD 前台（guard/ 各頁）共用腳本
 *
 * 由 system/core/function/include.inc 自動載入（js/ 目錄、每一頁都載入、字母序）。
 * 修改後須重新壓縮：terser web.init.js -c -m -o web.init.min.js
 *
 * ─────────────────────────────────────────────────────────────────────
 * 檔案結構（依功能分區，搜尋「【A】」…「【H】」可直接跳到該區）
 * ─────────────────────────────────────────────────────────────────────
 * 【A】核心與共用
 *      A1 調試開關、AJAX 全局設定（401 拒絕原因提示）
 *      A2 全域變數
 *      A3 通用工具（日期時間、StorageUtil、TimeoutManager、Modal、AJAX 錯誤）
 *      A4 PWA 初始化
 *      A5 設備編號管理（deviceId 存 localStorage）
 *      A6 頁面初始化 SetWeb() 與權限（allow_menu 存 sessionStorage，每次開頁向後端重取）
 * 【B】首頁待辦提醒條（#homeReminderBar：報更 / 簽到 / 巡邏的提醒，逾期彈窗控管）
 * 【C】定時報更
 *      C1 簡易版（現行）：到點響鬧 + 按鈕閃動 + 點擊撥 Twilio 電話報更（CALLSAFE_SIMPLE_MODE）
 *      C2 網頁內通話（Twilio Voice JS SDK，目前由 CALLSAFE_WEB_VOICE 關閉）
 *      C3 舊版：guard/callsafe.php 頁面狀態與預提交
 *      C4 舊版：報更人員選擇
 *      C5 舊版：報更提交（NFC / 拍照）
 * 【D】定點簽到（首頁提醒 + guard/fixedloc.php 簽到流程）
 * 【E】巡邏（guard/patrol.php）
 * 【F】門禁 / 考勤 / 相機頁初始化
 * 【G】警報與通知（倒計時、WebSocket 通知、警報聲與逾期彈窗）
 * 【H】統一事件綁定與其他處理（$(function) 內集中綁定各功能的按鈕事件）
 * 【I】共用：相機上傳、NFC 讀卡
 *
 * ─────────────────────────────────────────────────────────────────────
 * 維護注意
 * ─────────────────────────────────────────────────────────────────────
 * - 所有函數都是全域函數（其他檔案如 static/lib/camera/*.js、jquery.extend.js 也會呼叫），改名前先全專案搜尋。
 * - $(document).ready / $(function) 依「在本檔出現的先後」執行：
 *   A6 的 SetWeb() → H 的事件綁定 → H 的其他初始化。移動區塊時要保持這個先後。
 * - 頁面識別：currPages（由 PHP 輸出），SetWeb() 依它決定初始化哪個功能。
 * - 服務端接口：system/web/web.response.php（一般）、system/web/camera.response.php（拍照 / 人臉）、
 *   system/web/web.modal.php（彈窗 HTML）。被拒時回 HTTP 401 + {error, message}，由 A1 統一提示。
 */


// ##########################################################################
// 【A】核心與共用
//   所有頁面都會用到的基礎：全域變數、工具函數、設備編號、頁面初始化與權限。
//   其他區塊都依賴這裡，請勿把這一區移到後面。
// ##########################################################################

// ==================== A1 調試開關、AJAX 全局設定 ====================
// 401 回應（guardDeny）統一顯示拒絕原因；not_logged_in 時導回首頁重新人臉登入。
// 本地開發環境（__ISLOCALSERVER__ = true）保留 console 輸出
// 生產環境靜默所有 console.log，保留 console.error
(function() {
    if (typeof __ISLOCALSERVER__ !== 'undefined' && !__ISLOCALSERVER__) {
        console.log = function() {};
        console.info = function() {};
        console.debug = function() {};
        // 保留 console.warn 和 console.error 用於生產環境錯誤追蹤
    }
})();

// ==================== AJAX 全局默認值（前台） ====================
// CSRF token 注入由 jquery.extend.js 的 $.ajaxPrefilter 統一處理

// 服務端權限把關的統一提示（system/web/web.response.php 的 guardDeny：HTTP 401 + JSON）：
//   not_logged_in → 登入已過期（例如手機長時間鎖屏），提示後回首頁重新人臉登入
//   其他（device_invalid / menu_not_allowed / not_owner / point_not_allowed）→ 顯示服務端給的原因
// 沒有這段的話，使用者只會看到各處通用的「網絡錯誤」，不知道其實是要重新登入或設備設定有問題。
var _guardDenyHandled = false;
var _guardDenyLastShown = {};   // 同一種拒絕原因 30 秒內只提示一次（背景輪詢每分鐘會重複觸發）
$(document).ajaxError(function(event, xhr) {
    if (!xhr || xhr.status !== 401) return;
    var res = xhr.responseJSON;
    if (!res) { try { res = JSON.parse(xhr.responseText); } catch (e) { res = null; } }
    if (!res || !res.error) return;

    if (res.error === 'not_logged_in') {
        if (_guardDenyHandled) return;
        _guardDenyHandled = true;
        if (typeof showDelayMessage === 'function') showDelayMessage('登入已過期，請重新進行人臉登入', 'error', { duration: 2000 });
        setTimeout(function() { window.location.href = ROOTPATH + 'guard'; }, 2000);
        return;
    }
    var now = Date.now();
    if (_guardDenyLastShown[res.error] && now - _guardDenyLastShown[res.error] < 30000) return;
    _guardDenyLastShown[res.error] = now;
    if (typeof showDelayMessage === 'function') showDelayMessage(res.message || '操作被拒絕', 'error', { duration: 3500 });
});
// 此處只設置前台專屬的全局默認值
(function() {
    $.ajaxSetup({
        dataType: 'json',
        timeout: 30000
    });
})();

// ==================== A2 全域變數 ====================
// 各功能的狀態旗標；新功能的狀態建議放在各自區塊內（例：C1 的 _callsafeDial）。
// guard 功能頁（非首頁）：這些頁面要顯示提醒條，且只彈「自己」的超時 modal
var _GUARD_FUNCTION_PAGES = ['callsafe', 'patrol', 'fixedloc'];

var countdownTimer;                 // 倒計時定時器
var _audio;                         // 音頻對象
var _remindalarm = false;           // 提醒警報狀態
var _patrolalarm = false;           // 巡邏警報狀態
var _callsafealarm = false;         // 報更警報狀態
var _callsafeAudio;                 // 報更音頻對象
var _callTimeArr = null;            // 報更時間數組
var _callTimeArrLoaded = false;     // 報更時間是否已加載
var _imgeffecttimes = 0;            // 圖片效果計數器
var _callsafeModalShown = false;    // 報更超時 modal 是否已顯示
var _callTimeRequested = false;     // 获取报更时间配置

// NFC 相關全局變量
var _nfcModalId = null;             // 當前 NFC modal 的 ID
var _nfcTimeout = null;             // NFC 超時計時器
var _nfcReader = null;              // 當前 NFC reader 實例
var _nfcScanning = false;           // NFC 是否正在掃描
var _nfcRestartCount = 0;           // 靜默掃描連續重啟次數（防止無限循環）

var _fixedLocArr = null;            // 定點簽到時間數組
var _fixedLocArrLoaded = false;     // 定點簽到時間是否已加載
var _fixedLocModalShown = false;    // 定點簽到超時 modal 是否已顯示
var _fixedLocTimeout = null;        // 定點簽到超時定時器

//全局設備ID變量和獲取函數
var _deviceId = null;


// ==================== A3 通用工具函數 ====================

/**
 * 格式化數字為兩位數
 * @param {number} i - 數字
 * @returns {string} 兩位數字符串
 */
function formatTwoDigits(i) {
    return i < 10 ? '0' + i : '' + i;
}

/**
 * 獲取當前時間字符串 HH:MM:SS
 * @returns {string} 格式化時間
 */
function getCurrentTimeString() {
    var today = new Date();
    return formatTwoDigits(today.getHours()) + ':' + 
           formatTwoDigits(today.getMinutes()) + ':' + 
           formatTwoDigits(today.getSeconds());
}

/**
 * 獲取當前日期字符串 YYYY-MM-DD
 * @returns {string} 格式化日期
 */
// 本地日期 YYYY-MM-DD。原寫法 toISOString() 是 UTC 日期：香港 00:00–08:00 會得到「前一天」，
// 導致該時段送出的報更 / 簽到日期錯一天。可傳入 Date，預設現在。
function getCurrentDateString(d) {
    d = d || new Date();
    return d.getFullYear() + '-' + formatTwoDigits(d.getMonth() + 1) + '-' + formatTwoDigits(d.getDate());
}

/**
 * 通用 localStorage 存取工具
 */
var StorageUtil = {
    get: function(key, defaultValue) {
        defaultValue = (defaultValue === undefined) ? null : defaultValue;
        try {
            var value = localStorage.getItem(key);
            return value ? JSON.parse(value) : defaultValue;
        } catch (e) {
            console.error('讀取 localStorage 失敗:', key, e);
            return defaultValue;
        }
    },
    set: function(key, value) {
        try {
            localStorage.setItem(key, JSON.stringify(value));
            return true;
        } catch (e) {
            console.error('保存 localStorage 失敗:', key, e);
            return false;
        }
    },
    remove: function(key) {
        localStorage.removeItem(key);
    }
};

/**
 * 通用超時管理器
 */
var TimeoutManager = {
    timers: {},
    
    set: function(key, callback, delay) {
        this.clear(key);
        this.timers[key] = setTimeout(callback, delay);
        return this.timers[key];
    },
    
    clear: function(key) {
        if (this.timers[key]) {
            clearTimeout(this.timers[key]);
            delete this.timers[key];
        }
    },
    
    clearAll: function() {
        for (var key in this.timers) {
            if (this.timers.hasOwnProperty(key)) {
                clearTimeout(this.timers[key]);
            }
        }
        this.timers = {};
    }
};

/**
 * 通用模態框關閉函數
 * @param {string|jQuery} modal - 模態框選擇器或元素
 * @param {boolean} removeBodyClass - 是否移除 body 類
 */
function closeModal(modal, removeBodyClass) {
    removeBodyClass = (removeBodyClass === undefined) ? true : removeBodyClass;
    var $modal = typeof modal === 'string' ? $(modal) : modal;
    $modal.remove();
    if (removeBodyClass) {
        $("body").removeClass("modal-open");
    }
}

/**
 * 通用AJAX錯誤處理
 * @param {Function} onError - 錯誤回調
 * @returns {Function} 錯誤處理函數
 */
function createAjaxErrorHandler(onError) {
    return function(xhr, status, error) {
        console.error('AJAX 請求失敗:', error);
        if (typeof onError === 'function') {
            onError();
        } else {
            showDelayMessage('網絡錯誤，請稍後重試', 'error');
        }
    };
}

/**
 * 通用設備ID檢查
 * @param {boolean} autoInit - 是否自動初始化
 * @returns {string|null} 設備ID
 */
function requireDeviceId(autoInit) {
    autoInit = (autoInit === undefined) ? false : autoInit;
    var deviceId = getDeviceId();
    if (!deviceId && autoInit) {
        initDeviceIdManagement();
    }
    return deviceId;
}


// ==================== A4 PWA 初始化（設備編號確認後才初始化推送通知） ====================

/**
 * 設備 ID 設置成功後的回調
 */
function onDeviceIdVerified(deviceId) {
    console.log('設備 ID 驗證成功:', deviceId);
    
    // ✅ 設備編號確認後，主動彈出消息權限並把 endpoint + 設備編號一起記錄
    //    （PWA 的 Service Worker 註冊與安裝提示已由 static/pwa/pwa.init.min.js 自動處理，
    //      recordEndpointAfterInstall=false 時，安裝後不會自動彈，必須在此觸發）
    triggerNotificationWithDeviceId(deviceId);
}

/**
 * 設備編號確認後觸發消息權限請求（含設備編號記錄）
 */
function triggerNotificationWithDeviceId(deviceId) {
    if (!deviceId || deviceId === '0') return;
    // 確保 deviceId 已寫入 localStorage，供 PWA 核心 getDeviceIdGlobal 讀取
    try { localStorage.setItem('deviceId', deviceId); } catch (e) {}
    _deviceId = deviceId;

    if (window.PWAConfig && typeof window.PWAConfig.requestNotificationWithDeviceId === 'function') {
        // 重要：必須在「用戶手勢」（點擊「確認設備編號」的回調中）直接呼叫，
        // 否則瀏覽器會封鎖 Notification.requestPermission()，導致推送訂閱與
        // tbl_pushmanager 寫入永遠不會發生。Service Worker 是否在手勢當下就緒
        // 由 PWAConfig 內部以 navigator.serviceWorker.ready 等待，不影響手勢要求。
        window.PWAConfig.requestNotificationWithDeviceId(deviceId);
    }
}


// ==================== A5 設備編號管理 ====================
// deviceId 存 localStorage；首頁無設備編號時要求輸入（showDeviceIdInput）。

/**
 * 獲取設備ID（緩存版本）
 * @returns {string|null} 設備ID
 */
function getDeviceId() {
    if (_deviceId === null) {
        _deviceId = localStorage.getItem('deviceId');
    }
    return _deviceId;
}

/**
 * 設置設備ID
 * @param {string} id - 設備ID
 */
function setDeviceId(id) {
    if (id) {
        $(".js_device_badge").html(id);
        localStorage.setItem('deviceId', id);

        _deviceId = id;
    } else {
        console.error('setDeviceId 收到空 id');
    }
}

/**
 * 清除設備ID
 */
function clearDeviceId() {
    localStorage.removeItem('deviceId');
    localStorage.removeItem('allow_menu');
    localStorage.removeItem('allow_location');
    try { sessionStorage.removeItem('allow_menu'); } catch (e) {}
    try { sessionStorage.removeItem('allow_location'); } catch (e) {}
    _deviceId = null;
}

/**
 * 判斷 PWA 是否已安裝（與 pwa.core 的 isAppInstalled 對齊）
 */
function isPWAInstalled() {
    try {
        if (localStorage.getItem('pwa_installed') === 'true') return true;
        var appType = (window.PWAConfig && typeof window.PWAConfig.getCurrentAppType === 'function') ? window.PWAConfig.getCurrentAppType() : 'default';
        if (localStorage.getItem('pwa_installed_' + appType) === 'true') return true;
        var isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
        return isStandalone;
    } catch (e) {
        return false;
    }
}

/**
 * 統一流程：
 *  - 已有設備編號：直接返回（流程 B，左下角顯示編號，可 5 連點修改）
 *  - 無編號且未在 standalone 模式（未真正安裝）：先彈「安裝到主屏幕」提示，
 *    是否允許「稍後安裝」由 pwa.config.js 的 allowSkipInstall 控制
 *    （true = 顯示「稍後再說」可跳過，本地測試用；false = 強制立即安裝，正式上線手機端用）。
 *    安裝成功後刷新頁面 → 再進入即走「已安裝」分支彈出設備編號輸入框。
 *    另提供「暫不安裝，直接輸入編號」兜底，避免桌面等不支援安裝的環境卡死。
 *  - 無編號且已在 standalone 模式（已安裝 PWA）：直接彈設備編號輸入框（流程 A）
 */
function initDeviceIdManagement() {
    if(  currPages == "authn")
        return 'P01'; 

    const existingDeviceId = getDeviceId();
    
    // 如果已經有設備ID，直接返回（流程 B：顯示編號，5 連點可修改）
    if ( existingDeviceId ) {
        return existingDeviceId;
    }

    // 無設備編號：判斷是否已在 standalone 模式（真正已安裝，含從主畫面打開）。
    // ⚠️ 只用 display-mode: standalone 判斷，不再依賴 localStorage['pwa_installed_*']，
    //    避免本地測試時被舊值誤判為已安裝而跳過安裝提示。
    var isStandalone = false;
    try {
        isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
    } catch (e) { isStandalone = false; }

    if (!isStandalone) {
        // 未真正安裝 → 先彈安裝提示（是否允許稍後由 pwa.config 的 allowSkipInstall 控制）
        window.__DEVICE_ID_PENDING__ = true; // 禁止 pwa.core 自動彈（我們自己控制）
        var installShown = false;
        if (window.PWAConfig && typeof window.PWAConfig.forceInstallPWA === 'function') {
            installShown = window.PWAConfig.forceInstallPWA() === true;
        }

        if (!installShown) {
            // 安裝提示被 deferred（用戶已點「稍後再說」且在封鎖時間內）或環境不支援，
            // 不再強制彈出，直接進入設備編號輸入流程。
            showDeviceIdInput();
            return null;
        }

        // 安裝成功（含手動從主畫面打開）→ 刷新頁面，下次即走「已安裝」分支
        window.addEventListener('appinstalled', function() {
            setTimeout(function() { window.location.reload(); }, 800);
        });

        return null;
    }

    // 已安裝（standalone）→ 直接彈設備編號輸入框
    showDeviceIdInput();
    return null;
}

function showDeviceIdInput() {
    // 標記設備編號輸入中：禁止 pwa.core 自動彈安裝 modal（否則會遮擋輸入框）
    window.__DEVICE_ID_PENDING__ = true;

    var inputHtml = '<div class="guard-deviceid">' +
        '<p class="guard-deviceid-hint">請輸入設備編號以啟用本應用</p>' +
        '<input type="text" class="form-input" name="device_id" placeholder="設備編號" />' +
        '<span>提示：設備編號由管理員提供</span>' +
        '</div>';

    // 統一提示層：改用 myMsg.confirm（Promise）。舊 $.confirm().ok().cancel() 屬 jQuery-Confirm 舊 API，
    // my-msg 已將 $.confirm 陰影為 Promise（無 .ok()），殘留會直接 TypeError 並中斷整段設備編號流程。
    //
    // $deviceIdInput：myMsg 的 confirm 會在關閉時把整個 overlay 從 DOM 移除，callback 才執行；
    // 先同步抓住輸入框元素，即使節點已 detached，.val() 仍可讀到使用者輸入的值。
    var $deviceIdInput = null;

    myMsg.confirm("使用前需要設定設備編號", { body: inputHtml, okText: '確定', cancelText: '取消', backdropClose: false })
        .then(function(e) {
            if (e === true) {
                var deviceId = ($deviceIdInput && $deviceIdInput.length) ? $deviceIdInput.val() : '';

                if (deviceId && deviceId.trim() !== "") {
                    $.ajax({
                        type: 'POST',
                        url: ROOTPATH + 'system/web/web.response.php',
                        data: {
                            Subject: 'set_device',
                            device_id: deviceId
                        },
                        dataType: "json",
                        success: function(response) {
                            if (response.success === "success") {
                                setDeviceId(response.device_id);
                                
                                if (response.allow_menu) {
                                    setAllowMenu(response.allow_menu);
                                }
                                if (response.allow_location) {
                                    setAllowLocation(response.allow_location);
                                }
                                
                                showDelayMessage('設備編號驗證成功', 'success', {
                                    duration: 1500,
                                    position: 'top-center',
                                    customStyle: { fontSize: '22px', fontWeight: '700', padding: '16px 32px', maxWidth: '90vw', borderRadius: '12px' },
                                    onDurationEnd: function() {
                                        setTimeout(function() {
                                            applyMenuPermissions();
                                            
                                            var allowedMenus = getAllowMenu();
                                            if (allowedMenus.includes('fixedloc')) {
                                                initFixedLocSystem();
                                            }
                                        }, 100);
                                        
                                        // 設備 ID 驗證成功後，彈消息權限並記錄 endpoint + device_id
                                        // （若已授權則不再彈，直接重新記錄 endpoint；見 pwa.core requestNotificationWithDeviceId）
                                        onDeviceIdVerified(response.device_id);
                                    }
                                });
                            } else {
                                showDelayMessage('設備編號不正確', 'error', {
                                    duration: 2000,
                                    onDurationEnd: function() {
                                        // 舊輸入框在 confirm 關閉時已從 DOM 移除，直接重彈新框即可
                                        showDeviceIdInput();
                                    }
                                });
                            }
                        },
                        error: createAjaxErrorHandler(function() {
                            showDelayMessage('網絡錯誤，請稍後重試', 'error', {
                                duration: 2000,
                                onDurationEnd: function() {
                                    showDeviceIdInput();
                                }
                            });
                        })
                    });
                } else {
                    showDelayMessage('請輸入有效的設備編號', 'warning', {
                        duration: 2000,
                        onDurationEnd: function() {
                            showDeviceIdInput();
                        }
                    });
                }
            } else {
                window.location.href = ROOTPATH + 'guard/index.php';
            }
        }
    );
    
    // myMsg.confirm 會「同步」建立 overlay 與輸入框，故於此立即抓取（取最後一個 = 最新彈出的那個）
    $deviceIdInput = $('input[name=device_id]').last();

    setTimeout(function() {
        var $input = $('input[name=device_id]');
        $input.focus();
        
        $input.off('keypress.enter').on('keypress.enter', function(e) {
            if (e.which === 13 || e.keyCode === 13 || e.key === 'Enter') {
                e.preventDefault();
                $('.alert_btn_ok').trigger('click');
            }
        });
    }, 200);
}


// ==================== A6.0 首頁首屏載入閘 ====================
// 問題：首頁的狀態（權限、報更時間、該時段是否已報更、巡邏提醒）都要向伺服器逐一取得，
//       頁面先顯示、資料陸續回來再改畫面 → 先是普通頁面，1–2 秒後提醒條插入頂部、按鈕開始閃動（像刷新了一下），
//       甚至「出現 → 消失 → 出現」。
// 做法：首頁（currPages = 'guard'）載入時先隱藏 .guardpages，等以下首屏任務都有結果再一次顯示：
//         perm     設備權限（有快取時立即完成，否則等伺服器）
//         callsafe 是否在報更時段、該時段是否已報更
//         fixedloc 是否在定點簽到時段、該時段是否已簽到
//         patrol   巡邏提醒清單第一次回來
//       最多等 GUARD_BOOT_MAX_MS，逾時照常顯示（網絡慢時不會一直空白）。
var GUARD_BOOT_MAX_MS = 2000;
var _guardBoot = { pending: { perm: 1, callsafe: 1, fixedloc: 1, patrol: 1 }, done: false };

if (typeof currPages !== 'undefined' && currPages === 'guard') {
    document.documentElement.classList.add('guard-booting');
    setTimeout(guardBootReveal, GUARD_BOOT_MAX_MS);
} else {
    _guardBoot.done = true;
}

function guardBootDone(task) {
    if (_guardBoot.done) return;
    delete _guardBoot.pending[task];
    if (Object.keys(_guardBoot.pending).length === 0) guardBootReveal();
}

function guardBootReveal() {
    if (_guardBoot.done) return;
    _guardBoot.done = true;
    document.documentElement.classList.remove('guard-booting');
}

// ==================== A6 頁面初始化與權限 ====================
// SetWeb(currPages)：依頁面初始化對應功能。
// refreshDevicePermissions()：每次開頁向後端（set_device）重取 allow_menu / allow_location，
//   取回後套用按鈕顯示，並補啟動依權限的提醒（見【B】initHomeReminderSystem）。

/**
 * 獲取用戶權限列表
 * @returns {Array} 權限數組
 */
function getAllowMenu() {
    var allowMenuStr = readAllowSetting('allow_menu');
    if (!allowMenuStr) return [];
    return allowMenuStr.split(',').map(function(item) {
        return item.trim();
    });
}

/**
 * 讀取設備權限設定：優先 sessionStorage（每次載入會刷新），
 * 相容舊的 localStorage（避免升級當下已設定的設備瞬間失效）。
 * 改用 session 暫存後，後台調整 allow_menu / allow_location，
 * 重新整理頁面即可即時生效，不必重新設定設備。
 */
function readAllowSetting(key) {
    try {
        var v = sessionStorage.getItem(key);
        if (v !== null && v !== undefined) return v;
    } catch (e) {}
    try {
        return localStorage.getItem(key);
    } catch (e) { return null; }
}

// 權限同時寫入 localStorage：sessionStorage 在重開 App / 瀏覽器後是空的，readAllowSetting() 會退回 localStorage。
// 舊寫法只寫 sessionStorage，導致退回的是很久以前的舊值 → 首屏先用舊權限、伺服器回來再改一次（畫面跳動）。
// 每次開頁 refreshDevicePermissions() 仍會向伺服器取最新權限覆寫，後台改設定照樣即時生效。
/**
 * 設備「已知沒有」某板塊權限（allow_menu 已取得且不含該板塊）。
 * 權限尚未取得（空）時回 false，避免開頁瞬間誤判而把提醒關掉。
 * 用途：沒有權限的板塊，任何提醒（響鬧 / 閃動 / 提醒條）都不啟動、已啟動的也立即停止。
 */
function menuDenied(menu) {
    var menus = getAllowMenu();
    return menus.length > 0 && menus.indexOf(menu) === -1;
}

function setAllowMenu(val) {
    try { sessionStorage.setItem('allow_menu', val); } catch (e) {}
    try { localStorage.setItem('allow_menu', val); } catch (e) {}
}
function setAllowLocation(val) {
    try { sessionStorage.setItem('allow_location', val); } catch (e) {}
    try { localStorage.setItem('allow_location', val); } catch (e) {}
}

/**
 * 每次頁面載入時，依設備編號向後端重新拉取最新 allow_menu / allow_location，
 * 寫入 sessionStorage。後台修改設備設置後，只需重新整理頁面即可即時生效，
 * 不必重新設定設備（舊寫法存 localStorage 導致設定改了也不更新）。
 */
function refreshDevicePermissions() {
    var deviceId = getDeviceId();
    if (!deviceId) return;
    $.ajax({
        url: ROOTPATH + 'system/web/web.response.php',
        method: 'POST',
        dataType: 'json',
        data: { Subject: 'set_device', device_id: deviceId, deviceId: deviceId },
        success: function(response) {
            if (response && response.success) {
                setAllowMenu(response.allow_menu || '');
                setAllowLocation(response.allow_location || '');
                applyMenuPermissions();
                if (typeof applyLocationPermissions === 'function') applyLocationPermissions();

                // 權限取回後補啟動依權限的提醒（見 initHomeReminderSystem 說明）
                if (_homeReminderStarted.enabled) {
                    initHomeReminderSystem();
                }
                if (currPages === 'guard' && getAllowMenu().includes('fixedloc')) {
                    initFixedLocSystem();
                }
            }
        },
        complete: function() {
            guardBootDone('perm');
            // 伺服器確認此設備沒有定時報更權限 → 報更提示不會出現，首屏不必等它
            if (getAllowMenu().indexOf('callsafe') === -1) guardBootDone('callsafe');
            if (getAllowMenu().indexOf('fixedloc') === -1) guardBootDone('fixedloc');
            if (getAllowMenu().indexOf('patrol') === -1) guardBootDone('patrol');
        }
    });
}

/**
 * 根據權限控制菜單顯示
 */
function applyMenuPermissions() {
    var allowedMenus = getAllowMenu();
    
    console.log('允許的菜單權限:', allowedMenus);
    
    if (allowedMenus.length === 0) {
        $('.guard-func').addClass('ishidden');
        return;
    }
    
    $('.guard-func').each(function() {
        var $this = $(this);
        var menuId = $this.attr('id');
        
        if (menuId && allowedMenus.includes(menuId)) {
            $this.removeClass('ishidden');
        } else {
            $this.addClass('ishidden');
        }
    });
    
    // 只在「guard 首頁」執行「全無權限則重置設備編號」；
    // 子頁（patrol/callsafe/attendance/fixedloc/access/schedule）會被注入一個無 id 的
    // .guard-func（例如返回首頁按鈕），若在此判斷會誤判為「全無權限」而錯誤清空設備編號，
    // 因此必須限定 currPages === 'guard' 才執行重置
    if (currPages === 'guard' && $('.guard-func').length > 0 && $('.guard-func:not(.ishidden)').length === 0) {
        $.alert("沒有權限，重置設備編號", function() {
            clearDeviceId();
            window.location.href = ROOTPATH + 'guard';
        });
    }
}

/**
 * 監聽 localStorage 變化（用於多標籤頁同步）
 */
function watchStorageChanges() {
    window.addEventListener('storage', function(e) {
        if (e.key === 'allow_menu') {
            console.log('localStorage allow_menu 已變化，重新應用權限');
            applyMenuPermissions();
        }
    });
}

/**
 * 文檔準備就緒事件處理
 */
$(document).ready(function() {    
    SetWeb(currPages);
    refreshDevicePermissions();
});

/**
 * 窗口大小調整事件
 */
$(window).resize(function() {});

/**
 * 滾動事件處理
 */
$(window).scroll(function(event) {});

/**
 * 根據當前頁面設置相應的Web功能
 * @param {string} _Pages - 頁面標識符
 */
function SetWeb(_Pages) {   
    // 啟用浮動容器動畫效果
    if (!$(".floating-container").hasClass("active")) {
        $(".floating-container").addClass("active bounce");
    }
    // 代碼清理（2026-04-21）：移除調試代碼和不必要的 localStorage 清除
    //clearDeviceId();//清除設備編號
    
    // 設備編號 + 權限判定僅在 guard 首頁（index）需要；
    // 其餘頁面（如 monitor.php 監控頁、attendance/callsafe/patrol 等子頁）跳過，避免一進入就強制輸入設備編號或被踢出。
    const devicePages = ["guard"];

    if (devicePages.includes(_Pages)) {
        // 所有頁面都需要設備ID，所以在切換頁面前確保有設備ID
        const deviceId = getDeviceId();

        // 所有頁面都需要設備ID，所以在切換頁面前確保有設備ID
        if (!deviceId || deviceId === '0') {
            //不傳入任何回調，initDeviceIdManagement 會處理 PWA 初始化
            console.log('頁面切換時，發現無設備ID，初始化設備管理');
            guardBootReveal();   // 要顯示設備編號輸入窗，不必等首屏任務
            initDeviceIdManagement();
        } else {
            //權限初始化代碼
            if (_Pages === "guard") {
                // 已在 DOM ready 內執行，不再延遲（原 100ms 延遲只會讓首屏更晚決定）
                (function() {
                    applyMenuPermissions();

                    // 根據權限初始化對應的系統（權限有快取 → 首屏立即可用；伺服器回來後 refreshDevicePermissions 會再套用一次）
                    var allowedMenus = getAllowMenu();
                    // 首屏的 perm 任務只在「伺服器權限」回來後完成（見 refreshDevicePermissions 的 complete），
                    // 不以手機上的權限快取放行：快取可能是舊的（例如後台剛取消了報更權限），否則首屏會先按舊權限提示一下。

                    if (allowedMenus.includes('fixedloc')) {
                        initFixedLocSystem();
                    }

                    // 首頁統一待辦提醒條：報更/簽到/巡邏
                    initHomeReminderSystem();
                })();

                watchStorageChanges();
            } else if (_GUARD_FUNCTION_PAGES.indexOf(_Pages) !== -1) {
                // 第二層：功能頁（報更 / 巡邏 / 定點簽到）也要顯示提醒條，
                // 讓使用者隨時知道「還有哪些事沒做」。
                // 阻塞式 modal 由 canShowOvertimeModal() 控管，功能頁只會彈自己的。
                setTimeout(function() {
                    initHomeReminderSystem();
                }, 100);

                watchStorageChanges();
            }
        }
    }

    switch (_Pages) {
        case "guard":
            $(".js_device_badge").html(getDeviceId());
            break;
        case "callsafe":
            $(".js_device_badge").html(getDeviceId() || '未綁定');
            initCallsafeSystem();
            break;
        case "fastpass":
            initFastPassSystem();
            break;
        case "attendancecamera":
            initAttendanceCamera();
            break;
        case "accesscamera":
            initAccessCamera();
            break;
        case "patrol":
            initPatrolSystem();
            break;
        case "fixedloc":
            // 顯示當前設備編號（定點簽到不綁定設備，僅記錄簽到時使用的設備）
            $(".js_device_badge").html(getDeviceId() || '未綁定');
            break;
        case "safetycamera":
            initSafetyCamera();
            break;
    }
}



// ##########################################################################
// 【B】首頁待辦提醒條
//   頁面頂部 #homeReminderBar：常駐顯示需處理的報更 / 簽到 / 巡邏，逾期時閃爍。
//   setReminderTask(key, state) / clearReminderTask(key) 設定某類提醒；點擊提醒條執行 _reminderAction。
// ##########################################################################

// ==================== B1 提醒狀態與點擊動作 ====================

/**
 * 首頁任務提醒狀態集合
 * 結構: { callsafe: {active, level, text, href}, fixedloc: {...}, patrol: {...} }
 * level: 'info' | 'warning' | 'danger'
 */
var _reminderTasks = {
    callsafe: { active: false, level: '', text: '', href: '' },
    fixedloc: { active: false, level: '', text: '', href: '' },
    patrol:   { active: false, level: '', text: '', href: '' }
};

/**
 * 任務類型對應的首頁跳轉頁面（空字串表示不跳轉，改用點擊動作）
 * patrol / callsafe 與員工身份有關：不直接跳頁，改先做人臉識別登入
 */
var _reminderHref = {
    callsafe: '',
    fixedloc: 'guard/fixedloc.php',
    patrol:   ''
};

/**
 * 開啟人臉識別登入 modal（login_type 決定登入成功後導向的頁面）
 */
function openFaceLoginModal(loginType) {
    if (typeof openMyModal === 'function') {
        openMyModal({
            href: ROOTPATH + 'system/web/web.modal.php?flag=realtime_detect' +
                  '&currlang=' + (typeof currLang !== 'undefined' ? currLang : 'tc') +
                  '&detect=face_login&login=' + loginType
        });
    } else {
        window.location.href = ROOTPATH + 'guard/' + (loginType === 'patrol' ? 'patrol.php' : 'callsafe.php');
    }
}

/**
 * 任務類型對應的點擊動作（優先於 href 跳轉）
 * fixedloc 已有獨立頁面（不需員工登入），點擊直接跳轉
 * patrol / callsafe 點擊 → 先開人臉識別登入，登入成功後才會導向對應頁
 */
var _reminderAction = {
    fixedloc: function() { window.location.href = ROOTPATH + 'guard/fixedloc.php'; },
    patrol:   function() { openFaceLoginModal('patrol'); },
    callsafe: function() { CALLSAFE_SIMPLE_MODE ? callsafeDial() : openFaceLoginModal('callsafe'); }
};


// ==================== B2 提醒系統啟動、提醒條渲染、逾期彈窗控管 ====================
// initHomeReminderSystem() 可重複呼叫、每類只啟動一次（權限取回後會再呼叫）。
// checkCallsafeStatusHome() 為舊版報更用（CALLSAFE_SIMPLE_MODE=false 時才啟用）。
/**
 * 初始化首頁提醒系統：依權限啟動三類任務的輪詢
 *
 * 可重複呼叫、每類只啟動一次：權限（allow_menu）存在 sessionStorage，PWA / 瀏覽器重開後是空的，
 * 要等 refreshDevicePermissions() 向後端取回才知道。SetWeb() 在頁面載入 100ms 後呼叫時權限往往還沒回來，
 * 因此 refreshDevicePermissions() 取回權限後會再呼叫一次，補啟動尚未啟動的提醒
 * （原本只呼叫一次 → 重開 App 後「定時報更」按鈕有顯示，卻永遠不響、不閃）。
 */
var _homeReminderStarted = { enabled: false, callsafe: false, fixedloc: false, patrol: false };

function initHomeReminderSystem() {
    var allowedMenus = getAllowMenu();
    _homeReminderStarted.enabled = true;

    if (allowedMenus.includes('callsafe') && !_homeReminderStarted.callsafe) {
        _homeReminderStarted.callsafe = true;
        if (CALLSAFE_SIMPLE_MODE) {
            // 簡易版：到點響鬧 + 按鈕閃動 + 點擊撥電話報更（不做逾時判斷）
            initCallsafeDialReminder();
        } else {
            if (!_callTimeArrLoaded) {
                getCallTimeConfig();
            }
            setInterval(checkCallsafeStatusHome, 60000);
            checkCallsafeStatusHome();
        }
    }

    if (allowedMenus.includes('fixedloc') && !_homeReminderStarted.fixedloc) {
        _homeReminderStarted.fixedloc = true;
        if (FIXEDLOC_SIMPLE_MODE) {
            // 簡易版：準時提醒（見 D0），不再使用舊的 -3~+5 分提醒與逾時彈窗
            initFixedlocReminder();
        } else {
            if (!_fixedLocArrLoaded) {
                getFixedLocConfig();
            }
            setInterval(checkFixedLocStatusHome, 60000);
            checkFixedLocStatusHome();
        }
    }

    // 巡邏提醒：改由伺服器端取得「所有進行中巡邏」（含人員），
    // 首頁與各頁提醒條可同時顯示多條（哪位人員巡邏到哪、是否逾期），不阻擋操作
    // 只有設備有 patrol 權限才顯示巡邏提醒
    if (allowedMenus.includes('patrol') && !_homeReminderStarted.patrol) {
        _homeReminderStarted.patrol = true;
        refreshPatrolReminderList();
        setInterval(refreshPatrolReminderList, 60000);
    }

    updateReminderBar();
}

/**
 * 伺服器端進行中巡邏清單（多人），供提醒條逐條顯示
 */
var _patrolReminderItems = [];

function refreshPatrolReminderList() {
    if (menuDenied('patrol')) {          // 權限已被取消：清空巡邏提醒
        _patrolReminderItems = [];
        updateReminderBar();
        guardBootDone('patrol');
        return;
    }
    $.ajax({
        type: 'POST',
        url: ROOTPATH + 'system/web/web.response.php',
        data: { Subject: 'get_patrol_reminder_list' },
        dataType: 'json',
        success: function(data) {
            _patrolReminderItems = (data && data.patrols) || [];
            updateReminderBar();
        },
        error: function() { /* 靜默失敗：下次輪詢再試 */ },
        complete: function() { guardBootDone('patrol'); }
    });
}

/**
 * 設定某任務的提醒狀態並刷新提醒條
 * @param {string} key - callsafe | fixedloc | patrol
 * @param {Object} state - {active, level, text}
 */
function setReminderTask(key, state) {
    if (!_reminderTasks.hasOwnProperty(key)) return;
    _reminderTasks[key].active = !!state.active;
    _reminderTasks[key].level  = state.level || '';
    _reminderTasks[key].text   = state.text || '';
    _reminderTasks[key].href   = _reminderHref[key] || '';
    updateReminderBar();
}

/**
 * 清除某任務的提醒狀態
 * @param {string} key - callsafe | fixedloc | patrol
 */
function clearReminderTask(key) {
    setReminderTask(key, { active: false, level: '', text: '' });
}

/**
 * 提醒分層架構 —— 各層職責
 *
 *  第一層（伺服器端）：排程 +15 分未處理 → 自動撥打升級電話
 *                     （受 CALLSAFE_AUTO_DIAL / FIXEDLOC_AUTO_DIAL 開關管制）
 *  第二層（提醒條）  ：#homeReminderBar 常駐、永不阻塞，所有 guard 頁都可見
 *  第三層（功能頁）  ：各功能頁只彈「自己」的超時 modal，不干擾其他功能
 *  第四層（聲響）    ：警報音 + localStorage 跨頁同步
 */

/**
 * 確保提醒條存在（功能頁沒有內建時動態建立，讓跨頁可見性一致）
 * @returns {boolean} 提醒條是否存在
 */
function ensureReminderBar() {
    if ($('#homeReminderBar').length) return true;

    var $section = $('section').first();
    if (!$section.length) return false;

    $section.prepend(
        '<div id="homeReminderBar" class="guard-reminder-bar ishidden">' +
        '  <div class="rmb-icon">!</div>' +
        '  <div class="rmb-items"></div>' +
        '</div>'
    );
    return true;
}

/**
 * 判斷是否允許顯示「阻塞式」超時 modal
 *
 * 規則：首頁永遠可顯示；功能頁只能顯示「自己」的，
 * 避免在巡邏頁被報更超時 modal 打斷（反之亦然）。
 *
 * @param {string} type - 'callsafe' | 'patrol' | 'fixedloc'
 * @returns {boolean}
 */
function canShowOvertimeModal(type) {
    var page = (typeof currPages !== 'undefined') ? currPages : '';
    if (page === 'guard') return true;   // 首頁：所有提醒都可彈
    return page === type;                 // 功能頁：只彈自己的
}

/**
 * 逾時提示：第一次彈全屏 modal，之後僅用 toast，避免反覆打斷操作
 * @param {string} type - 'callsafe' | 'patrol'
 * @param {string|number} id - 對應 ID
 * @param {string} toastText - toast 文案
 */
function notifyOvertime(type, id, toastText) {
    // 已有 modal 開啟中（例如正在填寫延遲原因）→ 不堆疊，改用 toast
    if ($('.modal.show').length > 0) {
        showDelayMessage(toastText, 'warning', { duration: 5000 });
        return;
    }

    if (!canShowOvertimeModal(type)) {
        // 不在允許的頁面：只發 toast，不彈 modal
        showDelayMessage(toastText, 'warning', { duration: 5000 });
        return;
    }

    var shownKey = '_overtimeModalShown_' + type;
    if (window[shownKey]) {
        showDelayMessage(toastText, 'warning', { duration: 5000 });
        return;
    }

    window[shownKey] = true;
    showOvertimeModal(type, id);
}

/**
 * 重置「已彈過超時 modal」的旗標（任務完成 / 重新開始時呼叫）
 * @param {string} type - 'callsafe' | 'patrol'
 */
function resetOvertimeModalFlag(type) {
    window['_overtimeModalShown_' + type] = false;
}

/**
 * 渲染首頁提醒條（常駐，有任務才顯示，逾期才脈衝）
 */
function updateReminderBar() {
    // 功能頁（patrol / callsafe / fixedloc）沒有內建提醒條時動態建立，
    // 讓「還有哪些事沒做」在任何頁面都看得到（第二層：永不阻塞）
    if (!ensureReminderBar()) return;

    var $bar = $('#homeReminderBar');
    var $items = $bar.find('.rmb-items');
    $items.empty();

    var hasActive = false;
    var hasDanger = false;

    ['callsafe', 'fixedloc', 'patrol'].forEach(function(key) {
        var task = _reminderTasks[key];
        if (!task.active) return;
        hasActive = true;
        if (task.level === 'danger') hasDanger = true;

        var $item = $('<a>').addClass('rmb-item rmb-' + task.level)
            .text(task.text);

        // 若有指定點擊動作（如 fixedloc 觸發簽到 modal），優先使用
        if (typeof _reminderAction[key] === 'function') {
            $item.attr('href', 'javascript:void(0);')
                .on('click', function(e) {
                    e.preventDefault();
                    _reminderAction[key]();
                });
        } else if (task.href) {
            $item.attr('href', ROOTPATH + task.href);
        } else {
            $item.attr('href', '#');
        }

        $items.append($item);
    });

    // 伺服器端進行中巡邏（多人、多條）：逐條顯示人員/路線/進度/逾期
    // 點擊 → 人臉識別登入（不直接跳巡邏頁，防止未驗證進入他人巡邏路線）
    _patrolReminderItems.forEach(function(p) {
        var level = (parseInt(p.overdue, 10) > 0) ? 'danger' : 'info';
        hasActive = true;
        if (level === 'danger') hasDanger = true;

        var text = (p.staff_name || '未名員工') + '：' + (p.line_name || '巡邏') +
                   '（' + p.signed + '/' + p.total +
                   (parseInt(p.overdue, 10) > 0 ? '，' + p.overdue + ' 逾期' : '') + '）';

        var $pItem = $('<a>').addClass('rmb-item rmb-' + level).text(text)
            .attr('href', 'javascript:void(0);')
            .on('click', function(e) {
                e.preventDefault();
                if (typeof _reminderAction.patrol === 'function') _reminderAction.patrol();
            });
        $items.append($pItem);
    });

    if (hasActive) {
        $bar.removeClass('ishidden');
        $bar.toggleClass('rmb-danger', hasDanger);
    } else {
        $bar.addClass('ishidden');
        $bar.removeClass('rmb-danger');
    }

    // 整個提醒條（含 icon 與空白處）都可點擊，導向第一個（最高優先）任務
    $bar.off('click.rmbBar').on('click.rmbBar', function(e) {
        // 若點到的是內部項目連結，交給該項目自己的處理邏輯，避免重複觸發
        if ($(e.target).closest('a.rmb-item').length) return;
        var $firstItem = $items.find('a.rmb-item').first();
        if ($firstItem.length) $firstItem[0].click();
    });
}

/**
 * 首頁版報更檢查（不依賴子頁面 .nexthour span 元素）
 * 不傳 calltimepoint，讓後端自動計算下一報更點並回傳狀態
 */
function checkCallsafeStatusHome() {
    if (!_callTimeArr || _callTimeArr.length === 0) {
        // 尚未載入配置，等待 getCallTimeConfig 完成後會再呼叫
        return;
    }

    var today = new Date();
    if (!isNearCallTime(today)) {
        clearReminderTask('callsafe');
        return;
    }

    var deviceId = getDeviceId();
    if (!deviceId) return;

    $.ajax({
        type: 'POST',
        url: ROOTPATH + 'system/web/web.response.php',
        data: {
            Subject: "callsafe_pre_submit",
            deviceid: deviceId,
            calldatepoint: getCurrentDateString(),
            calltimepoint: '',
            current_time: new Date().toISOString(),
            is_background_check: 1
        },
        dataType: "json",
        success: function(data) {
            if (!data || !data.status) {
                clearReminderTask('callsafe');
                return;
            }
            var nextCall = (data.realtimepoint || data.next_call_time || '');
            switch (data.status) {
                case 'open':
                    clear_callsafe_alarm();
                    setReminderTask('callsafe', {
                        active: true, level: 'warning',
                        text: '報更時間到：' + nextCall + ' 請報更'
                    });
                    break;
                case 'overdue':
                case 'delayed':
                    add_callsafe_alarm();
                    setReminderTask('callsafe', {
                        active: true, level: 'danger',
                        text: '報更逾期：' + nextCall + ' 未報更'
                    });
                    break;
                default:
                    clear_callsafe_alarm();
                    clearReminderTask('callsafe');
            }
        },
        error: function() {
            // 網路失敗不清除已有狀態，靜默重試
        }
    });
}

/**
 * 首頁版定點簽到檢查（整合提醒條）
 */
function checkFixedLocStatusHome() {
    if (!_fixedLocArr || _fixedLocArr.length === 0) return;

    var currentTime = new Date();
    var nearFixedLoc = isNearFixedLocTime(currentTime);

    if (!nearFixedLoc) {
        clearReminderTask('fixedloc');
        return;
    }

    checkIfAlreadySigned(nearFixedLoc).then(function(alreadySigned) {
        if (alreadySigned) {
            clearReminderTask('fixedloc');
            return;
        }
        if (nearFixedLoc.diffMinutes < 0) {
            var minutesLeft = Math.abs(nearFixedLoc.diffMinutes);
            setReminderTask('fixedloc', {
                active: true, level: 'warning',
                text: minutesLeft + ' 分鐘後需定點簽到 (' + nearFixedLoc.time + ')'
            });
        } else if (nearFixedLoc.diffMinutes >= 0 && nearFixedLoc.diffMinutes <= 5) {
            if (nearFixedLoc.diffMinutes > 5) {
                setReminderTask('fixedloc', {
                    active: true, level: 'warning',
                    text: '請在 ' + nearFixedLoc.time + ' 進行定點簽到'
                });
            } else {
                setReminderTask('fixedloc', {
                    active: true, level: 'danger',
                    text: '定點簽到逾期：' + nearFixedLoc.time
                });
            }
        }
    });
}



// ##########################################################################
// 【C】定時報更
//   現行：C1 簡易版（電話報更）。報更時段 = 到點前 1 秒 ~ 到點後 1 小時（期間提醒且可點擊）；響鬧於到點前 1 秒開始。
//   電話接通後的語音流程在 system/integrations/twilio/CallsafeIvr.php（寫入 tbl_callsaferecord）。
//   C2 網頁內通話已停用；C3–C5 為舊版（人臉登入 + NFC / 拍照，guard/callsafe.php），保留以便恢復。
//   詳見 system/integrations/twilio/CALLSAFE_WEB_PLAN.md。
// ##########################################################################

// ==================== C1 簡易版：到點響鬧、按鈕閃動、點擊撥號 ====================
// 報更時間來自 guard/loadcallsafetime.php（tbl_callsafeline），每分鐘重新載入。
// 只有在報更時段內點擊才會撥號，其他時間提示「未到報更時間」。

/**
 * true  = 定時報更使用簡易版：按設備的報更時間（tbl_callsafeline）到點響鬧、首頁按鈕閃動，
 *         點擊直接撥 Twilio 號碼，由電話語音完成報更（system/integrations/twilio/CallsafeIvr.php）。
 * false = 恢復原版（人臉登入 + NFC/拍照，含逾時判斷）；同時須把 guard/index.php 的按鈕 id 換回。
 */
var CALLSAFE_SIMPLE_MODE = true;

var _callsafeDial = {
    times: [],          // 本設備報更時間 ['09:00', ...]
    audio: null,
    ringing: false,
    LEAD_SEC: 1,            // 到點前 1 秒開始響
    FIRST_RING_SEC: 15,     // 第一次連續響 15 秒
    MINUTE_RING_SEC: 10,    // 之後仍未報更：每個整分鐘（hh:mm:00）響 10 秒
    WINDOW_AFTER_SEC: 60 * 60, // 報更時段 = 到點後 1 小時：期間提醒（閃動 / 響鬧）且可點擊報更，之後不可點擊
    ACK_KEY: 'callsafe_dial_ack',
    TIMES_KEY: 'callsafe_times_',          // + 設備編號：上次取得的報更時間表（首屏立即判斷用）
    REPORTED_KEY: 'callsafe_reported',     // 已確認報更的時段（跨頁面 / 重開 App 保留，最近 2 天）
    timesLoaded: false,
    reported: {},     // 已確認成功報更的時間點 key（date+time）→ true，命中後不再提示
    checked: {},      // 已完成第一次回查的時間點 key → true（回查前不提示，避免已報更的時段先閃一下）
    _checking: null,  // 正在回查的 point.key（避免每秒 tick 重複發請求）
    _lastCheck: {}    // 各 point.key 上次回查時間戳（ms），20 秒內不重查
};

/**
 * 啟動提醒：載入本設備報更時間，之後每秒檢查一次。
 * 時間表每分鐘重新載入、頁面回到前景時也重新載入：後台修改報更時間後，已開著的頁面最多 1 分鐘內生效
 * （原本 30 分鐘才重載，改了時間後已開著的頁面會錯過新時間點）。
 */
function initCallsafeDialReminder() {
    // 只在 guard 首頁（index.php）提示：「定時報更」按鈕只在首頁，巡邏 / 簽到等頁面響鬧只會造成混亂
    if (typeof currPages === 'undefined' || currPages !== 'guard') return;
    if (initCallsafeDialReminder._started) return;
    initCallsafeDialReminder._started = true;

    // 先用上次的時間表（localStorage），開頁即可判斷是否在報更時段；伺服器回來再更新
    var cached = StorageUtil.get(_callsafeDial.TIMES_KEY + getDeviceId());
    if (Array.isArray(cached)) {
        _callsafeDial.times = cached;
        _callsafeDial.timesLoaded = true;
    }
    _callsafeDial.reported = pruneCallsafeReported(StorageUtil.get(_callsafeDial.REPORTED_KEY) || {});
    tickCallsafeDial();

    loadCallsafeDialTimes();
    setInterval(loadCallsafeDialTimes, 60 * 1000);
    document.addEventListener('visibilitychange', function() {
        if (document.visibilityState === 'visible') {
            loadCallsafeDialTimes();
            // 通常是打完電話從撥號盤回來：立即回查是否已報更，不必等下一輪 20 秒
            _callsafeDial._lastCheck = {};
        }
    });
    setInterval(tickCallsafeDial, 1000);
}

function loadCallsafeDialTimes() {
    var deviceId = getDeviceId();
    if (!deviceId) return;
    $.ajax({
        type: 'GET',
        url: ROOTPATH + 'guard/loadcallsafetime.php',
        data: { action: 'getCallTime', device_id: deviceId },
        dataType: 'json',
        success: function(data) {
            _callsafeDial.times = Array.isArray(data) ? data : [];
            StorageUtil.set(_callsafeDial.TIMES_KEY + deviceId, _callsafeDial.times);
        },
        // 失敗時保留上次的時間表，下次再試（不可退回寫死的預設時間，以免提醒錯的時間）
        complete: function() {
            _callsafeDial.timesLoaded = true;
            tickCallsafeDial();      // 立即判斷一次，不等下一秒
        }
    });
}

/** 已報更時段的快取只保留最近 2 天（key 為 "YYYY-MM-DD HH:MM"） */
function pruneCallsafeReported(map) {
    var out = {};
    var limit = getCurrentDateString(new Date(Date.now() - 2 * 86400000));
    Object.keys(map || {}).forEach(function(k) {
        if (k.substr(0, 10) >= limit) out[k] = true;
    });
    return out;
}

/**
 * 找出「正在提醒中」的報更時間點：到點前 1 秒 ~ 到點後 1 小時，含跨午夜（例 00:00 的更於 23:59:59 開始）
 * @returns {{key:string, label:string, start:number}|null}
 */
function getActiveCallsafePoint(now) {
    var nowMs = now.getTime();
    for (var i = 0; i < _callsafeDial.times.length; i++) {
        var parts = String(_callsafeDial.times[i]).split(':');
        if (parts.length < 2) continue;
        for (var dayOffset = -1; dayOffset <= 1; dayOffset++) {
            var t = new Date(now.getFullYear(), now.getMonth(), now.getDate() + dayOffset,
                             parseInt(parts[0], 10), parseInt(parts[1], 10), 0, 0);
            var start = t.getTime() - _callsafeDial.LEAD_SEC * 1000;
            var end   = t.getTime() + _callsafeDial.WINDOW_AFTER_SEC * 1000;
            if (nowMs >= start && nowMs < end) {
                // key = 'YYYY-MM-DD HH:MM'：月日必須補零，回查報更（callsafe_check_ontime）時直接當 call_date_point 比對
                return {
                    key:   t.getFullYear() + '-' + formatTwoDigits(t.getMonth() + 1) + '-' + formatTwoDigits(t.getDate()) + ' ' + _callsafeDial.times[i],
                    label: _callsafeDial.times[i],
                    start: start,
                    at:    t.getTime()          // 排定時間點（毫秒）
                };
            }
        }
    }
    return null;
}

/**
 * 每秒執行：決定是否閃動、是否響鬧
 * 響鬧節奏：到點前 1 秒起連續響 15 秒；之後仍未報更，每個整分鐘響 10 秒，直到點擊、已報更或到點後 1 小時
 */
function tickCallsafeDial() {
    if (menuDenied('callsafe') || _callsafeDial.denied) {   // 設備沒有報更權限：不提示（含權限被取消時立即停止）
        stopCallsafeDialAlert();
        guardBootDone('callsafe');
        return;
    }
    if (!_callsafeDial.timesLoaded) return;          // 時間表尚未取得（無快取且伺服器未回）
    var point = getActiveCallsafePoint(new Date());
    if (!point) {
        stopCallsafeDialAlert();
        guardBootDone('callsafe');
        // 提前 30 秒回查即將開始的時段是否已報更：到點前 1 秒即可準時開始響，不必等查詢結果
        var upcoming = getActiveCallsafePoint(new Date(Date.now() + 30000));
        if (upcoming) maybeCheckCallsafeReported(upcoming);
        return;
    }

    // 本時段已確認成功報更（DB 回查命中 tbl_callsaferecord）→ 不再提示，直到時段結束
    if (_callsafeDial.reported[point.key]) {
        stopCallsafeDialAlert();
        guardBootDone('callsafe');
        return;
    }

    // 視窗內週期性回查：電話 / IVR 報更成功會寫入 DB，命中後即停止閃動與提醒條
    maybeCheckCallsafeReported(point);

    // 本時段第一次回查結果回來之前不提示：否則已報更的時段會先閃一下（甚至響一聲）才停
    // （開頁時常見：時間表載入 → 立即閃動 → 約 50ms 後查到已報更 → 停止）。查詢失敗也會標記，照常提示，不會漏提醒。
    if (!_callsafeDial.checked[point.key]) {
        return;
    }
    guardBootDone('callsafe');

    // 閃動與提醒條在整個報更時段內持續（到點前 1 秒 ~ 到點後 1 小時），點擊報更後也不停：
    // 時段內可多次報更（例如另一位同事），直到時段結束才消失。點擊只停止響鬧聲。
    $('#callsafe').addClass('remindflash');
    setReminderTask('callsafe', {
        active: true, level: 'warning',
        text: '報更時間 ' + point.label + '：請點擊撥打電話報更'
    });

    if (StorageUtil.get(_callsafeDial.ACK_KEY) === point.key) {
        setCallsafeDialRinging(false);
        return;
    }

    // 響鬧節奏：到點前 1 秒起連續響 15 秒；之後未報更則每個整分鐘（秒數 00–09）響 10 秒
    var now = new Date();
    var elapsed = (now.getTime() - point.start) / 1000;
    var shouldRing = (elapsed < _callsafeDial.FIRST_RING_SEC) || (now.getSeconds() < _callsafeDial.MINUTE_RING_SEC);
    setCallsafeDialRinging(shouldRing);
}

/**
 * 視窗內週期性回查本時段是否已成功報更（電話 / IVR 寫入 tbl_callsaferecord）。
 * 命中 is_ontime='ontime' 即標記 reported，使 tickCallsafeDial 不再提示、並立即收起閃動與提醒條。
 * 節流：每秒 tick 不重複發請求，同一時間點 20 秒內只查一次，且上一次未回應不重發。
 */
function maybeCheckCallsafeReported(point) {
    var key = point.key;
    var now = Date.now();
    if (_callsafeDial._checking === key) return;                        // 上一次請求尚未回應
    if (now - (_callsafeDial._lastCheck[key] || 0) < 20000) return;     // 20 秒內不再查
    _callsafeDial._checking = key;
    _callsafeDial._lastCheck[key] = now;

    var parts = key.split(' ');
    $.ajax({
        type: 'POST',
        url: ROOTPATH + 'system/web/web.response.php',
        data: {
            Subject: 'callsafe_check_ontime',
            device_id: getDeviceId(),
            check_date: parts[0] || '',
            check_time: parts[1] || point.label
        },
        dataType: 'json',
        global: false,   // 不觸發全域 401 提示（設備未開通報更時由下面 error 靜默處理）
        success: function(data) {
            if (data && data.is_ontime === 'ontime') {
                _callsafeDial.reported[key] = true;
                StorageUtil.set(_callsafeDial.REPORTED_KEY, pruneCallsafeReported(_callsafeDial.reported));
                stopCallsafeDialAlert();
            }
        },
        error: function(xhr) {
            if (xhr && xhr.status === 401) _callsafeDial.denied = true;   // 伺服器：此設備沒有報更權限 → 不再提示
        },
        complete: function() {
            _callsafeDial._checking = null;
            _callsafeDial.checked[key] = true;   // 成功或失敗都標記：失敗時照常提示，不漏提醒
            tickCallsafeDial();
        }
    });
}

function setCallsafeDialRinging(on) {
    if (on === _callsafeDial.ringing) return;
    _callsafeDial.ringing = on;

    if (on) {
        if (!_callsafeDial.audio) {
            _callsafeDial.audio = new Audio(ROOTPATH + 'static/images/alarm02.wav');
            _callsafeDial.audio.loop = true;
        }
        // 瀏覽器規定頁面需先有一次觸控才允許播放；被拒時不報錯，仍有閃動與提醒條
        var p = _callsafeDial.audio.play();
        if (p && p.catch) p.catch(function() {});
    } else if (_callsafeDial.audio) {
        _callsafeDial.audio.pause();
        _callsafeDial.audio.currentTime = 0;
    }
}

function stopCallsafeDialAlert() {
    setCallsafeDialRinging(false);
    $('#callsafe').removeClass('remindflash');
    if (_reminderTasks.callsafe.active) {
        clearReminderTask('callsafe');
    }
}

/**
 * 點擊「定時報更」：只在報更時段內（到點前 1 秒 ~ 到點後 1 小時）可報更，直接撥 Twilio 號碼；超過 1 小時不可點擊。
 * 是否準時由電話語音流程判斷（system/integrations/twilio/CallsafeIvr.php）：排定時間起 5 分鐘內準時；5–20 分鐘不依時；
 * 超過 20 分鐘為超時補報（歸屬該時間點，並錄音說明遲報原因）。
 * 點擊後停止本時段的響鬧聲（換頁或重開也不再響；閃動保留至時段結束或已報更）。
 */
function callsafeDial() {
    var point = getActiveCallsafePoint(new Date());
    if (!point) {
        showDelayMessage('不在報更時間內（報更時間後 1 小時內才可報更）', 'error');
        return;
    }
    StorageUtil.set(_callsafeDial.ACK_KEY, point.key);
    setCallsafeDialRinging(false);

    if (typeof CALLSAFE_WEB_VOICE !== 'undefined' && CALLSAFE_WEB_VOICE) {
        startCallsafeWebCall();
    } else {
        callsafeDialByPhone();
    }
}

/** 後備：開啟手機撥號盤撥 Twilio 號碼 */
function callsafeDialByPhone() {
    if (!CALLSAFE_TEL) {
        showDelayMessage('未設定報更電話號碼', 'error');
        return;
    }
    window.location.href = 'tel:' + CALLSAFE_TEL;
}

$(document).on('click', '.js_callsafe_dial', function(e) {
    e.preventDefault();
    callsafeDial();
});


// ==================== C2 網頁內通話（Twilio Voice JS SDK，目前停用） ====================
// 開關：system/config/general.char.inc 的 CALLSAFE_WEB_VOICE_ENABLED；關閉時 callsafeDial() 改開手機撥號盤。
// Token 由 system/web/web.response.php 的 callsafe_voice_token 簽發。
//
// 不經手機撥號盤：瀏覽器以網絡（WebRTC）連到 Twilio，再接到語音報更流程（system/integrations/twilio/CallsafeIvr.php）。
// 頁面上的按鍵以 DTMF 送出；掛斷後關閉通話面板，留在 guard 頁面。
// 需要：https、麥克風權限、網絡。任何一步失敗都退回 tel: 撥號盤。

var _callsafeVoice = {
    SDK_URL: 'static/lib/twilio/twilio-voice-2.18.5.min.js',
    sdkLoading: null,
    device: null,
    call: null,
    timer: null,
    startedAt: 0,
    digitsTimer: null
};

/** 首次使用才載入 SDK（約 300KB），之後重用 */
function loadTwilioVoiceSdk() {
    if (window.Twilio && window.Twilio.Device) return Promise.resolve();
    if (!_callsafeVoice.sdkLoading) {
        _callsafeVoice.sdkLoading = new Promise(function(resolve, reject) {
            var s = document.createElement('script');
            s.src = ROOTPATH + _callsafeVoice.SDK_URL;
            s.onload = resolve;
            s.onerror = function() {
                _callsafeVoice.sdkLoading = null;
                reject(new Error('sdk_load_failed'));
            };
            document.head.appendChild(s);
        });
    }
    return _callsafeVoice.sdkLoading;
}

function fetchCallsafeVoiceToken() {
    return new Promise(function(resolve, reject) {
        $.ajax({
            type: 'POST',
            url: ROOTPATH + 'system/web/web.response.php',
            data: { Subject: 'callsafe_voice_token', device_id: getDeviceId() },
            dataType: 'json',
            success: function(data) {
                if (data && data.success && data.token) resolve(data.token);
                else reject(new Error((data && data.message) || 'token_failed'));
            },
            error: function() { reject(new Error('token_request_failed')); }
        });
    });
}

function startCallsafeWebCall() {
    if (_callsafeVoice.call) {
        showCallsafeCallPanel();     // 已在通話中：只重新顯示面板
        return;
    }
    if (!window.isSecureContext || !navigator.mediaDevices) {
        callsafeDialByPhone();
        return;
    }

    showCallsafeCallPanel();
    setCallsafeCallStatus('連接中…');

    Promise.all([loadTwilioVoiceSdk(), fetchCallsafeVoiceToken()])
        .then(function(results) {
            var token = results[1];
            _callsafeVoice.device = new Twilio.Device(token, {
                codecPreferences: ['opus', 'pcmu'],
                edge: ['singapore', 'tokyo', 'roaming'],
                closeProtection: '通話進行中，確定要離開嗎？',
                logLevel: 'error'
            });
            _callsafeVoice.device.on('error', function(err) {
                console.error('[callsafe] Twilio Device 錯誤', err);
            });
            return _callsafeVoice.device.connect();
        })
        .then(function(call) {
            _callsafeVoice.call = call;

            call.on('accept', function() {
                _callsafeVoice.startedAt = Date.now();
                setCallsafeCallStatus('通話中 00:00');
                _callsafeVoice.timer = setInterval(function() {
                    var sec = Math.floor((Date.now() - _callsafeVoice.startedAt) / 1000);
                    setCallsafeCallStatus('通話中 ' + formatTwoDigits(Math.floor(sec / 60)) + ':' + formatTwoDigits(sec % 60));
                }, 1000);
            });
            call.on('disconnect', function() { endCallsafeWebCall('通話已結束'); });
            call.on('cancel',     function() { endCallsafeWebCall('通話已取消'); });
            call.on('reject',     function() { endCallsafeWebCall('通話被拒絕'); });
            call.on('error', function(err) {
                console.error('[callsafe] 通話錯誤', err);
                endCallsafeWebCall('通話出錯');
            });
        })
        .catch(function(err) {
            console.error('[callsafe] 網頁通話無法開始，改用撥號盤', err);
            endCallsafeWebCall('', true);
            // 麥克風被拒、SDK 或 token 失敗：退回手機撥號盤，確保仍能報更
            var micDenied = err && (err.name === 'NotAllowedError' || /permission/i.test(err.message || ''));
            showDelayMessage(micDenied ? '未允許使用麥克風，改用電話撥號' : '網頁通話無法連接，改用電話撥號', 'error');
            setTimeout(callsafeDialByPhone, 1200);
        });
}

function endCallsafeWebCall(message, immediate) {
    clearInterval(_callsafeVoice.timer);
    _callsafeVoice.timer = null;
    if (_callsafeVoice.call) {
        try { _callsafeVoice.call.disconnect(); } catch (e) {}
        _callsafeVoice.call = null;
    }
    if (_callsafeVoice.device) {
        try { _callsafeVoice.device.destroy(); } catch (e) {}
        _callsafeVoice.device = null;
    }
    if (immediate) {
        hideCallsafeCallPanel();
        return;
    }
    setCallsafeCallStatus(message || '通話已結束');
    $('#callsafeCallPanel').addClass('is-ended');
    setTimeout(hideCallsafeCallPanel, 1200);
}

/** 通話面板：狀態、輸入顯示、按鍵盤、掛斷 */
function showCallsafeCallPanel() {
    var $panel = $('#callsafeCallPanel');
    if (!$panel.length) {
        var keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];
        var keyHtml = keys.map(function(k) {
            return '<button type="button" class="ccp-key js_ccp_key" data-key="' + k + '">' + k + '</button>';
        }).join('');
        $panel = $(
            '<div id="callsafeCallPanel" class="callsafe-call-panel" role="dialog" aria-label="定時報更通話">' +
            '  <div class="ccp-box">' +
            '    <div class="ccp-title">定時報更</div>' +
            '    <div class="ccp-status js_ccp_status">連接中…</div>' +
            '    <div class="ccp-digits js_ccp_digits">&nbsp;</div>' +
            '    <div class="ccp-keypad">' + keyHtml + '</div>' +
            '    <button type="button" class="ccp-hangup js_ccp_hangup">掛斷</button>' +
            '  </div>' +
            '</div>'
        ).appendTo('body');
    }
    $panel.removeClass('is-ended').addClass('is-open');
    $('.js_ccp_digits').html('&nbsp;');
}

function hideCallsafeCallPanel() {
    $('#callsafeCallPanel').removeClass('is-open is-ended');
}

function setCallsafeCallStatus(text) {
    $('.js_ccp_status').text(text);
}

$(document).on('click', '.js_ccp_key', function() {
    var key = String($(this).data('key'));
    if (!_callsafeVoice.call) return;
    _callsafeVoice.call.sendDigits(key);

    // 顯示已按的鍵；停手 2 秒或按 # 後自動清空，方便輸錯時重新輸入
    var $d = $('.js_ccp_digits');
    $d.text(($d.text().trim() + key));
    clearTimeout(_callsafeVoice.digitsTimer);
    _callsafeVoice.digitsTimer = setTimeout(function() { $d.html('&nbsp;'); }, key === '#' ? 600 : 2000);
});

$(document).on('click', '.js_ccp_hangup', function() {
    endCallsafeWebCall('通話已結束');
});


// ==================== C3 舊版：報更頁狀態與預提交（guard/callsafe.php） ====================

/**
 * 自动刷新报更时间显示
 */
function autoRefreshCallsafeTime() {
    if (currPages !== "callsafe") return;
    
    var deviceId = getDeviceId();
    if (!deviceId) return;
    
    setInterval(function() {
        load_callsafe_time_html(deviceId);
        
        if (_callTimeArr && _callTimeArr.length > 0) {
            var today = new Date();
            var shouldCheck = isNearCallTime(today);
            if (shouldCheck) {
                checkCallsafeStatus();
            }
        }
    }, 60000);
}

/**
 * 初始化報更安全系統
 */
function initCallsafeSystem() {
    load_callsafe_time_html(getDeviceId());
    startCallsafeTime();
    autoRefreshCallsafeTime();
}

/**
 * 啟動報更時間監控系統
 */
function startCallsafeTime() {
    if (!_callTimeArrLoaded) {
        getCallTimeConfig();
    }
    
    var callsafeTimeElement = document.getElementById('callsafetime');
    if (callsafeTimeElement) {
        callsafeTimeElement.innerHTML = getCurrentTimeString();
    }
    
    if (_callTimeArr && _callTimeArr.length > 0) {
        var today = new Date();
        var shouldCheck = isNearCallTime(today);
        if (shouldCheck) {
            checkCallsafeStatus();
        } else {
            $("section").removeClass("alarmflash");
            _callsafeModalShown = false;
        }
    }
    
    setTimeout(startCallsafeTime, 1000);
}

/**
 * 检查是否需要进行报更状态检查
 * @param {Date} currentTime - 当前时间
 * @returns {boolean} 是否需要检查
 */
function isNearCallTime(currentTime) {
    if (!_callTimeArr || _callTimeArr.length === 0) return false;
    
    var currentHour = currentTime.getHours();
    var currentMinute = currentTime.getMinutes();
    var currentTotalMinutes = currentHour * 60 + currentMinute;
    
    for (var i = 0; i < _callTimeArr.length; i++) {
        var callTime = _callTimeArr[i];
        var parts = callTime.split(':');
        var callHour = parseInt(parts[0], 10);
        var callMinute = parseInt(parts[1], 10);
        var callTotalMinutes = callHour * 60 + callMinute;
        
        var diffMinutes = currentTotalMinutes - callTotalMinutes;
        
        if (diffMinutes < -12 * 60) {
            diffMinutes += 24 * 60;
        }
        
        if (diffMinutes >= -5 && diffMinutes <= 20) {
            return true;
        }
    }
    
    return false;
}

/**
 * 动态获取报更时间配置
 */
function getCallTimeConfig() {
    if (_callTimeRequested) {
        return;
    }
    _callTimeRequested = true;
    
    var deviceId = getDeviceId();
    
    $.ajax({
        type: 'GET',
        url: ROOTPATH + 'guard/loadcallsafetime.php',
        data: {
            action: 'getCallTime',
            device_id: deviceId
        },
        dataType: "json",
        success: function(data) {
            if (data && Array.isArray(data)) {
                _callTimeArr = data;
                _callTimeArrLoaded = true;
                checkCallsafeStatus();
            }
        },
        error: function() {
            _callTimeArr = ['01:00', '03:00', '05:00', '07:00', '11:00', '15:00', '19:00', '21:00', '23:00'];
            _callTimeArrLoaded = true;
        }
    });
}

/**
 * 检查报更状态
 */
function checkCallsafeStatus() {
    if (!_callTimeArr || _callTimeArr.length === 0) return;
    
    unifiedCallsafePreSubmit({
        isBackgroundCheck: true
    });
}

/**
 * 更新報更狀態條文字與樣式
 * @param {string} text - 顯示文字
 * @param {string} stateClass - 狀態類別：pending/done/overdue
 */
function setCallsafeStatus(text, stateClass) {
    var $val = $('#callsafe-status-value');
    if (!$val.length) return;
    $val.text(text || '').removeClass('pending done overdue').addClass(stateClass || '');
}

/**
 * 更新报更UI
 */
function updateCallsafeUI(response) {
    var container = $('.callsafe-container');
    var button = $('.js_callsafe_pre_submit');
    
    if (!container.length || !button.length) return;
    
    switch(response.status) {
        case 'waiting':
            container.find('.next-call-info').remove();
            container.append(
                '<div class="next-call-info">' +
                '報更時間: ' + response.next_call_time +
                '</div>'
            );
            setCallsafeStatus('下一報更時間：' + (response.next_call_time || '—'), 'pending');
            break;
            
        case 'open':
            button.show()
                .removeClass('btnyellow btnred')
                .addClass('btngreen')
                .text('平安更')
                .data({
                    calldatepoint: response.realdatepoint,
                    calltimepoint: response.realtimepoint,
                    status: 'open'
                });
            container.find('.next-call-info').remove();
            setCallsafeStatus('可進行報更（' + (response.realtimepoint || '—') + '）', 'done');
            break;
            
        case 'overdue':
            button.show()
                .removeClass('btngreen btnred')
                .addClass('btnyellow')
                .text('不依时报更')
                .data({
                    calldatepoint: response.realdatepoint,
                    calltimepoint: response.realtimepoint,
                    status: 'overdue'
                });
            container.find('.next-call-info').remove();
            setCallsafeStatus('報更已逾期：' + (response.realtimepoint || '—'), 'overdue');
            break;
            
        case 'delayed':
            button.show()
                .removeClass('btngreen btnyellow')
                .addClass('btnred')
                .text('延遲報更')
                .data({
                    calldatepoint: response.realdatepoint,
                    calltimepoint: response.realtimepoint,
                    status: 'delayed'
                });
            container.find('.next-call-info').remove();
            setCallsafeStatus('上一更未報，請補更（' + (response.realtimepoint || '—') + '）', 'overdue');
            
            if (!_callsafeModalShown) {
                _callsafeModalShown = true;
            }
            break;
            
        default:
            setCallsafeStatus('下一報更時間：' + (response.next_call_time || '—'), 'pending');
            break;
    }
}

/**
 * 处理预提交响应
 */
function handleCallsafePreSubmitResponse(response, button) {
    switch(response.success) {
        case "allow_submit":
            showCallsafeModal(response.status, response);
            break;
            
        case "waiting_submit":
            showDelayMessage('尚未到報更時間', 'error');
            // 隱藏下方的「報更時間:」軸（status-bar 已顯示時間，此處重複）
            $('.callsafe-container .nexthour').hide();
            break;
            
        case "last_not_submit":
            showCallsafeModal('delayed', response);
            break;
            
        case "already_submitted":
            setCallsafeStatus('本時段已報更', 'done');
            showDelayMessage('已经报更', 'info', {
                duration: 2000,
                onDurationEnd: function() {
                    load_callsafe_time_html(getDeviceId());
                }
            });
            break;
    }
}

/**
 * 显示报更modal
 */
function showCallsafeModal(status, callDetail) {
    openMyModal({ href: ROOTPATH + 'system/web/web.modal.php?flag=callsafe_staff&' +
        'calldatepoint=' + callDetail.realdatepoint +
        '&calltimepoint=' + callDetail.realtimepoint +
        '&status=' + status +
        '&device_id=' + getDeviceId() +
        '&currlang=' + currLang });
}

/**
 * 統一的報更預提交檢查函數
 * @param {Object} options - 配置選項
 */
function unifiedCallsafePreSubmit(options) {
    options = options || {};
    var isBackgroundCheck = options.isBackgroundCheck || false;
    var element = options.element || null;
    var callback = options.callback || null;
    
    var deviceId = getDeviceId();
    var calldatepoint, calltimepoint;
    
    if (isBackgroundCheck) {
        calldatepoint = getCurrentDateString();
        
        var timeSpan = $('.nexthour span');
        if (timeSpan.length === 0) {
            console.log('未找到報更時間顯示元素');
            return;
        }
        calltimepoint = timeSpan.text().trim();
    } else {
        if (!element) {
            console.error('用戶點擊時缺少元素參數');
            return;
        }
        
        calldatepoint = element.data("calldatepoint");
        calltimepoint = element.data("calltimepoint");
        
        clear_patrol_remind();
        _remindalarm = true;
        if (element) {
            element.removeClass("remindalarm");
        }
    }
    
    $.ajax({
        type: 'POST',
        url: ROOTPATH + 'system/web/web.response.php',
        data: {
            Subject: "callsafe_pre_submit",
            deviceid: deviceId,
            calldatepoint: calldatepoint,
            calltimepoint: calltimepoint,
            current_time: new Date().toISOString(),
            is_background_check: isBackgroundCheck ? 1 : 0
        },
        dataType: "json",
        success: function(data) {
            if (isBackgroundCheck) {
                updateCallsafeUI(data);
                
                if (data.status === 'delayed' || data.status === 'overdue') {
                    $("section").addClass("alarmflash");
                } else if (data.status === 'open' || data.status === 'waiting') {
                    $("section").removeClass("alarmflash");
                }
            } else {
                handleCallsafePreSubmitResponse(data, element);
                
                if (typeof callback === 'function') {
                    callback(data);
                }
            }
        },
        error: function() {
            console.error('報更預提交檢查失敗');
            
            if (!isBackgroundCheck) {
                showDelayMessage('報更檢查失敗，請稍後重試', 'error');
            }
        }
    });
}

/**
 * 時間格式化輔助函數 - 確保數字是兩位數
 * @param {number} i - 時間數字
 * @returns {string} 格式化後的兩位數時間
 */
function checkCallsafeTime(i) {
    return formatTwoDigits(i);
}

/**
 * 載入報更時間HTML內容
 * @param {string} device_id - 設備ID
 */
function load_callsafe_time_html(device_id) {
    device_id = device_id || '';
    if (!device_id) {
        device_id = requireDeviceId(false);
        if (!device_id) {
            setCallsafeStatus('設備未綁定，無法載入報更時間', 'overdue');
            return;
        }
    }

    $.ajax({
        type: 'POST',
        url: ROOTPATH + 'system/web/web.response.php',
        data: {
            Subject: "load_callsafe_time_html",
            currlang: currLang,
            device_id: device_id
        },
        dataType: "json",
        success: function(data) {
            if (!data || !data.output) {
                setCallsafeStatus('載入失敗，請重試', 'overdue');
                return;
            }
            $(".patrol-options").find(".callsafe-container").remove();
            $(".patrol-options").append(data.output);

            // 狀態條根據 display_type 顯示對應文案
            var $container = $('.callsafe-container').first();
            var displayType = $container.data('display-type') || 'none';
            var displayTime = $container.data('display-time') || '';
            switch (displayType) {
                case 'current':
                    setCallsafeStatus('可進行報更（' + displayTime + '）', 'done');
                    break;
                case 'upcoming':
                    setCallsafeStatus('下一報更時間：' + displayTime, 'pending');
                    break;
                case 'overdue':
                    setCallsafeStatus('不依時報更：' + displayTime + '（仍可報更）', 'overdue');
                    break;
                case 'missed':
                    setCallsafeStatus('漏報可補報：' + displayTime, 'overdue');
                    break;
                case 'none':
                default:
                    setCallsafeStatus('未設定報更排程', 'overdue');
                    break;
            }

            if (_callTimeArr && _callTimeArr.length > 0) {
                var today = new Date();
                var shouldCheck = isNearCallTime(today);
                if (shouldCheck) {
                    checkCallsafeStatus();
                }
            }
        },
        error: function() {
            setCallsafeStatus('載入失敗，請重試', 'overdue');
        }
    });
}


// ==================== C4 舊版：報更人員選擇 ====================

/**
 * 人员选择辅助函数 - 从输入框获取用户ID数组
 * 输入框內容格式：「姓名(編號)/...」，純姓名(無括號)也允許
 * @param {jQuery} $input - 输入框元素
 * @returns {Array} 用户ID数组（数字字串）
 */
function getStaffIdsFromInput($input) {
    // 優先從 tokens 取 ID（輸入框只顯示姓名，真正的 ID 存在 data('staffTokens')）
    var tokens = $input.data('staffTokens') || [];
    if (tokens.length) {
        return tokens.map(function(t) { return String(t.id); });
    }

    var value = $input.val().trim();
    if (!value) return [];

    // 手動輸入：優先取「(編號)」格式；都沒有的純編號用 / , 空格切分
    var result = [];
    var idRe = /\((\d+)\)/g;
    var m;
    while ((m = idRe.exec(value)) !== null) {
        result.push(m[1]);
    }
    // 兼容舊資料：若完全沒有 (編號) 格式，沿用舊的 / 切分
    if (result.length === 0) {
        return value.split(/[\/,，\s]+/).filter(function(id) { return id.trim() !== ''; });
    }
    return result;
}

/**
 * 添加人员到输入框（顯示為「姓名(編號)」）
 * @param {Array} currentIds - 当前ID数组
 * @param {string} userId - 要添加的用户ID
 * @param {string} userName - 要顯示的姓名（可省略，省略時只用編號）
 * @param {jQuery} $input - 输入框元素
 */
function addStaffId(currentIds, userId, userName, $input) {
    if (!userId) return;

    if (currentIds.includes(userId)) {
        return;
    }

    currentIds.push(userId);
    // 顯示：只顯示姓名（ID 存在 tokens 內，提交時取用）；無姓名才退回編號
    var tokens = $input.data('staffTokens') || [];
    var display = userName ? userName : userId;
    tokens.push({ id: userId, name: userName, display: display });
    $input.data('staffTokens', tokens);
    $input.val(tokens.map(function(t) { return t.display; }).join('/'));
}

/**
 * 从输入框移除人员
 * @param {Array} currentIds - 当前ID数组
 * @param {string} userId - 要移除的用户ID
 * @param {jQuery} $input - 输入框元素
 */
function removeStaffId(currentIds, userId, $input) {
    if (!userId) return;

    var newIds = currentIds.filter(function(id) {
        return String(id) !== String(userId);
    });

    var tokens = ($input.data('staffTokens') || []).filter(function(t) {
        return String(t.id) !== String(userId);
    });
    $input.data('staffTokens', tokens);
    $input.val(tokens.map(function(t) { return t.display; }).join('/'));
}

/**
 * 根据输入框值更新人员选择状态
 * @param {jQuery} $input - 输入框元素
 * @param {jQuery} $container - 人员项容器
 */
function updateStaffSelection($input, $container) {
    if (!$container.length) return;
    
    var currentIds = getStaffIdsFromInput($input);
    
    $container.find('.js_select_staff_item').removeClass('activing');
    
    for (var i = 0; i < currentIds.length; i++) {
        var userIdStr = String(currentIds[i]).trim();
        
        $container.find('.js_select_staff_item').each(function() {
            var itemUserId = String($(this).data('userid')).trim();
            if (itemUserId === userIdStr) {
                $(this).addClass('activing');
            }
        });
    }
}


// ==================== C5 舊版：報更提交（NFC / 拍照） ====================

/**
 * 收集報更表單數據
 * @param {jQuery} element - 點擊元素
 * @returns {Object|null} 收集到的數據，驗證失敗時返回 null
 */
function collectCallsafeFormData(element) {
    var status = element.data("status");
    var calldatepoint = element.data("calldatepoint");
    var calltimepoint = element.data("calltimepoint");
    var deviceid = getDeviceId();
    
    var userids = [];
    var useridsInput = $(".js_staff_ids_input").val();
    
    if (useridsInput) {
        userids = getStaffIdsFromInput($(".js_staff_ids_input"));
    }
    
    var delayReason = '';
    var delayRemark = '';
    
    if (status !== 'open') {
        var $delayReasonSelect = $('input[name=delay_reason]');
        var $delayRemarkInput = $('input[name=delay_remark]');
        
        if ($delayReasonSelect.length > 0) {
            delayReason = $delayReasonSelect.val();
            
            if (!delayReason) {
                showDelayMessage('必須填寫延遲原因', 'warning');
                return null;
            }
            
            if (delayReason === '3' || delayReason === 'other') {
                delayRemark = $delayRemarkInput.val() || '';
                
                if (!delayRemark || delayRemark.trim() === '') {
                    showDelayMessage('請填寫延遲原因說明', 'success', {
                        duration: 2000,
                        onDurationEnd: function() {
                            $delayRemarkInput.focus();
                        }
                    });
                    return null;
                }
            }
        }
        
        if ($delayRemarkInput.length > 0 && !delayReason) {
            delayRemark = $delayRemarkInput.val() || '';
        }
    }
    
    if (userids.length === 0) {
        showDelayMessage('請至少選擇一位報更人員', 'info');
        return null;
    }
    
    return {
        status: status,
        calldatepoint: calldatepoint,
        calltimepoint: calltimepoint,
        deviceid: deviceid,
        userids: userids,
        delayReason: delayReason,
        delayRemark: delayRemark
    };
}

/**
 * 處理報更提交（NFC 方式）
 * @param {jQuery} element - 點擊元素
 */
function handleCallsafeSubmit(element) {
    var data = collectCallsafeFormData(element);
    if (!data) return;
    
    window._pendingCallsafeData = {
        status: data.status,
        calldatepoint: data.calldatepoint,
        calltimepoint: data.calltimepoint,
        deviceid: data.deviceid,
        userids: data.userids,
        delayReason: data.delayReason,
        delayRemark: data.delayRemark,
        sign_type: '',
        nfc_read_code: '',
        nfc_read_serial: '',
        photo: ''
    };
    
    handleNFCScan(element, 'callsafe');
}

/**
 * 處理報更拍照提交
 * @param {jQuery} element - 點擊元素
 */
function handleCallsafePhotoSubmit(element) {
    var data = collectCallsafeFormData(element);
    if (!data) return;
    
    window._pendingCallsafeData = {
        status: data.status,
        calldatepoint: data.calldatepoint,
        calltimepoint: data.calltimepoint,
        deviceid: data.deviceid,
        userids: data.userids,
        delayReason: data.delayReason,
        delayRemark: data.delayRemark,
        sign_type: 'photo',
        nfc_read_code: '',
        nfc_read_serial: '',
        photo: ''
    };
    
    startPhotoSubmission('callsafe', element);
}

/**
 * 處理報更NFC數據
 * @param {string} nfc_read_code - NFC讀取的code
 * @param {string} serialNumber - NFC序列號
 * @param {jQuery} element - 點擊元素
 */
function handleCallsafeNFC(nfc_read_code, serialNumber, element) {
    $.ajax({
        type: 'POST',
        url: ROOTPATH + 'system/web/web.response.php',
        data: {
            Subject: "validate_callsafe_nfc_card",
            nfc_read_code: nfc_read_code,
            nfc_read_serial: serialNumber,
            device_id: getDeviceId()
        },
        dataType: "json",
        success: function(response) {
            if (response.success && response.is_valid) {
                if (!window._pendingCallsafeData) {
                    element.removeClass("clickdisabled");
                    return;
                }
                
                window._pendingCallsafeData.nfc_read_code = nfc_read_code;
                window._pendingCallsafeData.nfc_read_serial = serialNumber;
                window._pendingCallsafeData.sign_type = 'nfc';
                
                setTimeout(function() {
                    submitCallsafeData();
                }, 100);
            } else {
                showNFCConfirm(
                    'callsafe',
                    function() {
                        handleNFCScan($(this), 'callsafe');
                    },
                    null,
                    null,
                    '驗證失敗，請使用正確的NFC卡或選擇其他方式'
                );
            }
        },
        error: createAjaxErrorHandler(function() {
            showNFCConfirm(
                'callsafe',
                function() {
                    handleNFCScan($(this), 'callsafe');
                },
                null,
                null,
                'NFC驗證失敗，請重試或選擇其他方式'
            );
        })
    });
}

/**
 * 提交報更數據到後台
 */
function submitCallsafeData() {
    if (window._isSubmittingCallsafe) {
        console.log('正在提交中，跳過重複提交');
        return;
    }
    
    if (!window._pendingCallsafeData) {
        console.error('沒有待提交的報更數據');
        return;
    }
    
    window._isSubmittingCallsafe = true;
    
    var data = window._pendingCallsafeData;
    
    console.log('提交報更數據:', data);
    
    $.ajax({
        type: 'POST',
        dataType: "json",
        url: ROOTPATH + 'system/web/web.response.php',
        data: {
            Subject: "callsafe_submit",
            deviceid: data.deviceid,
            calldatepoint: data.calldatepoint,
            calltimepoint: data.calltimepoint,
            userids: JSON.stringify(data.userids),
            delay_reason: data.delayReason,
            delay_remark: data.delayRemark,
            report_status: data.status,
            sign_type: data.sign_type,
            nfc_read_code: data.nfc_read_code || '',
            nfc_read_serial: data.nfc_read_serial || '',
            photo: data.photo || ''
        },
        success: function(responseData) {
            window._isSubmittingCallsafe = false;
            handleCallsafeSubmitResponse(responseData, data);
        },
        error: function(xhr, status, error) {
            window._isSubmittingCallsafe = false;
            console.error('提交失敗:', error);
            console.error('響應:', xhr.responseText);
            
            delete window._pendingCallsafeData;
            
            $.alert('提交失敗，請檢查網絡連接');
        }
    });
}

/**
 * 處理報更提交響應
 * @param {Object} responseData - 響應數據
 * @param {Object} originalData - 原始提交數據
 */
function handleCallsafeSubmitResponse(responseData, originalData) {
    console.log('提交響應:', responseData);
    
    delete window._pendingCallsafeData;
    
    if (responseData.success === "callsafe_success") {
        var successMessage = '';
        switch(originalData.status) {
            case 'open':
                successMessage = '平安更報更成功';
                break;
            case 'overdue':
                successMessage = '不依時報更成功';
                break;
            case 'delayed':
                successMessage = '延遲報更成功';
                break;
            default:
                successMessage = '報更成功';
        }
        
        if (originalData.sign_type === 'nfc') {
            successMessage += ' (NFC感應)';
        } else if (originalData.sign_type === 'photo') {
            successMessage += ' (拍照)';
        }
        
        $.alert(successMessage, function() {
            $('.modal').remove();
            $("body").removeClass("modal-open");
            load_callsafe_time_html(originalData.deviceid);
        });
    } else {
        $.alert('提交失敗: ' + (responseData.error || '未知錯誤'));
    }
}

/**
 * 處理報更相機響應
 * @param {Object} data - 響應數據
 */
function handleCallsafeCameraResponse(data) {
    // 關閉上傳中提示
    if (window._callsafeUploadToast) {
        window._callsafeUploadToast.remove();
        window._callsafeUploadToast = null;
    }

    if (data.success === "submit_success" || data.success === "callsafe_success") {
        $('.modal').remove();
        $("body").removeClass("modal-open");
        $('#camera-container').removeClass("activing");

        var deviceid = window._pendingCallsafeData ? window._pendingCallsafeData.deviceid : getDeviceId();
        load_callsafe_time_html(deviceid);

        if (window._pendingCallsafeData) {
            var status = window._pendingCallsafeData.status;
            var msg = '報更成功';
            if (status === 'open') msg = '平安更報更成功';
            else if (status === 'overdue') msg = '不依時報更成功';
            else if (status === 'delayed') msg = '延遲報更成功';
            
            showDelayMessage(msg + ' (拍照)', 'success', {
                duration: 2000,
                onDurationEnd: function() {
                    delete window._pendingCallsafeData;
                }
            });
        }
    } else if (data.error) {
        showDelayMessage('提交失敗' + data.error, 'error');
    }
}

// 當相機確認按鈕（modal 關閉）或用戶取消時，也清掉上傳中提示
$(document).on('click', '#camera-callsafe-checkin-cancel, .js_camera_modal_close', function() {
    if (window._callsafeUploadToast) {
        window._callsafeUploadToast.remove();
        window._callsafeUploadToast = null;
    }
});

/**
 * 處理報更預提交（用戶點擊）
 * @param {jQuery} element - 點擊元素
 */
function handleCallsafePreSubmit(element) {
    unifiedCallsafePreSubmit({
        isBackgroundCheck: false,
        element: element,
        callback: function(data) {
            console.log('用戶點擊預提交完成:', data);
        }
    });
}



// ##########################################################################
// 【D】定點簽到
//   D1：首頁到點提醒與逾時處理；D2：guard/fixedloc.php 的簽到流程（NFC 為主、拍照後備）。
//   服務端：system/web/web.response.php 的 fixedloc_submit / validate_fixedloc_nfc_card / fixedloc_photo。
// ##########################################################################

// ==================== D0 定點簽到首頁提醒（簡易版，與定時報更提醒一致） ====================
// 時段：到點 ~ 到點後 20 分鐘（伺服器 fixedloc_status 計算，一個點位可有多個時間）。
// 到點前 1 秒起：「定點簽到」按鈕閃動 + 提醒條 + 響鬧（連續 15 秒，之後每個整分鐘響 10 秒），
// 該時段已簽到 / 時段結束即停止。只在 guard 首頁提示。點擊按鈕進入簽到頁（js_fixedloc_signin），並停止本時段響鬧。
// 漏簽不升級撥打；舊版 D1（-3~+5 分提醒、整頁閃紅、逾時彈窗 + 自動撥號）由 FIXEDLOC_SIMPLE_MODE 停用。

var FIXEDLOC_SIMPLE_MODE = true;

var _fixedlocRemind = {
    slots: [],              // fixedloc_status 回傳的時段
    loaded: false,
    offset: 0,              // 伺服器時間 - 本機時間（毫秒）
    audio: null,
    ringing: false,
    lastLoad: 0,
    CACHE_KEY: 'fixedloc_slots_',   // + 設備編號：上次的時段狀態（首屏立即判斷）
    ACK_KEY: 'fixedloc_remind_ack'  // 已點擊（停止響鬧）的時段 key
};

function initFixedlocReminder() {
    if (typeof currPages === 'undefined' || currPages !== 'guard') return;
    if (initFixedlocReminder._started) return;
    initFixedlocReminder._started = true;

    var cached = StorageUtil.get(_fixedlocRemind.CACHE_KEY + getDeviceId());
    if (cached && Array.isArray(cached.slots) && cached.date === getCurrentDateString()) {
        _fixedlocRemind.slots = cached.slots;
        _fixedlocRemind.loaded = true;
    }
    tickFixedlocReminder();

    loadFixedlocStatus();
    setInterval(tickFixedlocReminder, 1000);
    document.addEventListener('visibilitychange', function() {
        if (document.visibilityState === 'visible') loadFixedlocStatus();
    });

    // 點擊「定點簽到」：停止本時段響鬧（按鈕本身會跳轉到簽到頁）
    $(document).on('click', '#fixedloc', function() {
        var active = getActiveFixedlocSlots();
        if (active.length) StorageUtil.set(_fixedlocRemind.ACK_KEY, active.map(fixedlocSlotKey).join('|'));
        setFixedlocRinging(false);
    });
}

function fixedlocSlotKey(s) {
    return s.id + '@' + s.date + ' ' + s.time;
}

function loadFixedlocStatus() {
    var deviceId = getDeviceId();
    if (!deviceId) return;
    _fixedlocRemind.lastLoad = Date.now();
    $.ajax({
        type: 'POST',
        url: ROOTPATH + 'system/web/web.response.php',
        data: { Subject: 'fixedloc_status', device_id: deviceId },
        dataType: 'json',
        global: false,   // 不觸發全域 401 提示
        error: function(xhr) {
            if (xhr && xhr.status === 401) { _fixedlocRemind.denied = true; _fixedlocRemind.slots = []; }
        },
        success: function(data) {
            if (!data || !Array.isArray(data.slots)) return;
            _fixedlocRemind.slots = data.slots;
            if (data.servertime) _fixedlocRemind.offset = data.servertime * 1000 - Date.now();
            StorageUtil.set(_fixedlocRemind.CACHE_KEY + deviceId, { date: getCurrentDateString(), slots: data.slots });
        },
        complete: function() {
            _fixedlocRemind.loaded = true;
            tickFixedlocReminder();
        }
    });
}

/** 正在提醒中的時段：未簽到，且現在在「到點前 1 秒 ~ 時段結束」之間 */
function getActiveFixedlocSlots() {
    var now = (Date.now() + _fixedlocRemind.offset) / 1000;
    return _fixedlocRemind.slots.filter(function(s) {
        return s.state !== 'signed' && now >= s.start - 1 && now <= s.end;
    });
}

function tickFixedlocReminder() {
    if (menuDenied('fixedloc') || _fixedlocRemind.denied) {   // 設備沒有簽到權限：不提示（含權限被取消時立即停止）
        setFixedlocRinging(false);
        $('#fixedloc').removeClass('remindflash');
        if (_reminderTasks.fixedloc.active) clearReminderTask('fixedloc');
        guardBootDone('fixedloc');
        return;
    }
    if (!_fixedlocRemind.loaded) return;

    // 每 60 秒更新；提醒中每 20 秒更新（簽到後盡快停止）
    var active = getActiveFixedlocSlots();
    var interval = active.length ? 20000 : 60000;
    if (Date.now() - _fixedlocRemind.lastLoad >= interval) loadFixedlocStatus();

    if (!active.length) {
        setFixedlocRinging(false);
        $('#fixedloc').removeClass('remindflash');
        if (_reminderTasks.fixedloc.active) clearReminderTask('fixedloc');
        guardBootDone('fixedloc');
        return;
    }

    var names = [];
    active.forEach(function(s) { if (names.indexOf(s.title) === -1) names.push(s.title); });
    $('#fixedloc').addClass('remindflash');
    setReminderTask('fixedloc', {
        active: true, level: 'warning',
        text: '定點簽到 ' + active[0].time + '：' + names.join('、') + ' 請簽到'
    });
    guardBootDone('fixedloc');

    var acked = String(StorageUtil.get(_fixedlocRemind.ACK_KEY) || '').split('|');
    var allAcked = active.every(function(s) { return acked.indexOf(fixedlocSlotKey(s)) !== -1; });
    if (allAcked) {
        setFixedlocRinging(false);
        return;
    }

    // 響鬧節奏與定時報更相同：到點前 1 秒起連續響 15 秒；之後每個整分鐘（秒數 00–09）響 10 秒
    var nowMs = Date.now() + _fixedlocRemind.offset;
    var elapsed = nowMs / 1000 - (active[0].start - 1);
    var shouldRing = (elapsed < _callsafeDial.FIRST_RING_SEC) || (new Date(nowMs).getSeconds() < _callsafeDial.MINUTE_RING_SEC);
    setFixedlocRinging(shouldRing);
}

function setFixedlocRinging(on) {
    if (on === _fixedlocRemind.ringing) return;
    _fixedlocRemind.ringing = on;
    if (on) {
        if (!_fixedlocRemind.audio) {
            _fixedlocRemind.audio = new Audio(ROOTPATH + 'static/images/alarm02.wav');
            _fixedlocRemind.audio.loop = true;
        }
        var p = _fixedlocRemind.audio.play();
        if (p && p.catch) p.catch(function() {});
    } else if (_fixedlocRemind.audio) {
        _fixedlocRemind.audio.pause();
        _fixedlocRemind.audio.currentTime = 0;
    }
}


// ==================== D1 定點簽到：時間配置、到點提醒、逾時處理 ====================

/**
 * 初始化定點簽到系統
 */
function initFixedLocSystem() {
    if (FIXEDLOC_SIMPLE_MODE) return;          // 簡易版停用舊的首頁簽到檢查 / 逾時彈窗 / 自動撥號（改用 D0）
    if (initFixedLocSystem._started) return;   // 可能於權限取回後再次呼叫，只啟動一次
    initFixedLocSystem._started = true;
    if (!_fixedLocArrLoaded) {
        getFixedLocConfig();
    }
    
    startFixedLocTime();
    setInterval(checkFixedLocStatus, 60000);
}

/**
 * 動態獲取定點簽到時間配置
 */
function getFixedLocConfig() {
    // 定點簽到不綁定設備：所有點位設定全站共用，device_id 僅為相容保留
    var deviceId = getDeviceId() || '';

    $.ajax({
        type: 'POST',
        url: ROOTPATH + 'system/web/web.response.php',
        data: {
            Subject: 'get_fixedloc_time',
            device_id: deviceId
        },
        dataType: "json",
        success: function(data) {
            if (data && Array.isArray(data)) {
                _fixedLocArr = data;
                _fixedLocArrLoaded = true;
                saveFixedLocConfigToStorage(data);
                console.log('定點簽到配置已加載:', _fixedLocArr);
                checkFixedLocStatus();
            }
        },
        error: createAjaxErrorHandler(function() {
            var localConfig = getFixedLocConfigFromStorage();
            if (localConfig) {
                _fixedLocArr = localConfig;
                _fixedLocArrLoaded = true;
                console.log('從本地存儲加載定點簽到配置:', _fixedLocArr);
            }
        })
    });
}

/**
 * 啟動定點簽到時間監控
 */
function startFixedLocTime() {
    updateCurrentTime();
    setTimeout(startFixedLocTime, 1000);
}

/**
 * 更新當前時間顯示
 */
function updateCurrentTime() {
    var currentTime = getCurrentTimeString();
    var timeElement = $('.current-time-display');
    if (timeElement.length) {
        timeElement.text(currentTime);
    }
}

/**
 * 檢查是否接近定點簽到時間
 * @param {Date} currentTime - 當前時間
 * @returns {Object|null} 返回接近的簽到點信息或null
 */
function isNearFixedLocTime(currentTime) {
    if (!_fixedLocArr || _fixedLocArr.length === 0) return null;
    
    var currentHour = currentTime.getHours();
    var currentMinute = currentTime.getMinutes();
    var currentTotalMinutes = currentHour * 60 + currentMinute;
    
    for (var i = 0; i < _fixedLocArr.length; i++) {
        var fixedLoc = _fixedLocArr[i];
        
        if (!fixedLoc.time) continue;
        
        var timeParts = fixedLoc.time.split(':');
        if (timeParts.length < 2) continue;
        
        var locHour = parseInt(timeParts[0], 10);
        var locMinute = parseInt(timeParts[1], 10);
        
        if (isNaN(locHour) || isNaN(locMinute)) continue;
        
        var locTotalMinutes = locHour * 60 + locMinute;
        var diffMinutes = currentTotalMinutes - locTotalMinutes;
        
        if (diffMinutes < -12 * 60) {
            diffMinutes += 24 * 60;
        }
        
        if (diffMinutes >= -3 && diffMinutes <= 5) {
            var result = {};
            for (var key in fixedLoc) {
                if (fixedLoc.hasOwnProperty(key)) {
                    result[key] = fixedLoc[key];
                }
            }
            result.diffMinutes = diffMinutes;
            return result;
        }
    }
    
    return null;
}

/**
 * 檢查定點簽到狀態
 */
function checkFixedLocStatus() {
    if (!_fixedLocArr || _fixedLocArr.length === 0) return;
    
    var currentTime = new Date();
    var nearFixedLoc = isNearFixedLocTime(currentTime);
    
    if (nearFixedLoc) {
        checkIfAlreadySigned(nearFixedLoc).then(function(alreadySigned) {
            if (!alreadySigned) {
                if (nearFixedLoc.diffMinutes < 0) {
                    showFixedLocReminder(nearFixedLoc);
                } else if (nearFixedLoc.diffMinutes >= 0 && nearFixedLoc.diffMinutes <= 5) {
                    handleFixedLocCheckinWindow(nearFixedLoc);
                }
            } else {
                clearReminderTask('fixedloc');
            }
        });
    } else {
        $("section").removeClass("alarmflash");
        _fixedLocModalShown = false;
        clearReminderTask('fixedloc');
    }
}

/**
 * 檢查是否已經簽到
 * @param {Object} fixedLoc - 定點簽到信息
 * @returns {Promise<boolean>} 是否已簽到
 */
function checkIfAlreadySigned(fixedLoc) {
    return new Promise(function(resolve) {
        $.ajax({
            type: 'POST',
            url: ROOTPATH + 'system/web/web.response.php',
            data: {
                Subject: "check_fixedloc_signed",
                fixedloc_id: fixedLoc.id || 0,
                device_id: getDeviceId() || '',
                check_date: getCurrentDateString(),
                check_time: fixedLoc.time
            },
            dataType: "json",
            success: function(response) {
                resolve(response.already_signed || false);
            },
            error: function() {
                resolve(false);
            }
        });
    });
}

/**
 * 顯示定點簽到提醒
 * @param {Object} fixedLoc - 定點簽到信息
 */
function showFixedLocReminder(fixedLoc) {
    $("section").addClass("alarmflash");

    var minutesLeft = Math.abs(fixedLoc.diffMinutes);
    var message = minutesLeft + '分鐘後需要定點簽到 (' + fixedLoc.time + ')';

    setReminderTask('fixedloc', {
        active: true, level: 'warning',
        text: minutesLeft + ' 分鐘後需定點簽到 (' + fixedLoc.time + ')'
    });

    showDelayMessage(message, 'warning', {
        duration: 5000,
    });
}

/**
 * 處理定點簽到檢查窗口
 * @param {Object} fixedLoc - 定點簽到信息
 */
function handleFixedLocCheckinWindow(fixedLoc) {
    $("section").addClass("alarmflash");

    var message = '請在' + fixedLoc.time + '進行定點簽到';
    setReminderTask('fixedloc', {
        active: true, level: (fixedLoc.diffMinutes > 5 ? 'warning' : 'danger'),
        text: (fixedLoc.diffMinutes > 5 ? '請在 ' + fixedLoc.time + ' 進行定點簽到' : '定點簽到逾期：' + fixedLoc.time)
    });

    showDelayMessage(message, 'info', {
        duration: 3000,
    });
    
    if (fixedLoc.diffMinutes > 0 && !_fixedLocTimeout) {
        var overtimeMinutes = 5;
        var remainingMinutes = overtimeMinutes - fixedLoc.diffMinutes;
        
        if (remainingMinutes > 0) {
            _fixedLocTimeout = TimeoutManager.set('fixedLocCheckin', function() {
                triggerFixedLocOvertime(fixedLoc);
            }, remainingMinutes * 60 * 1000);
        } else {
            triggerFixedLocOvertime(fixedLoc);
        }
    }
}

/**
 * 觸發定點簽到超時處理
 * @param {Object} fixedLoc - 定點簽到信息
 */
function triggerFixedLocOvertime(fixedLoc) {
    TimeoutManager.clear('fixedLocCheckin');
    _fixedLocTimeout = null;
    
    if (!_fixedLocModalShown) {
        showFixedLocOvertimeModal(fixedLoc);
        _fixedLocModalShown = true;
    }
    
    triggerFixedLocTwilio(fixedLoc);
}

/**
 * 顯示定點簽到超時modal
 * @param {Object} fixedLoc - 定點簽到信息
 */
function showFixedLocOvertimeModal(fixedLoc) {
    var modalId = 'fixedloc_overtime_modal_' + makeid(8);
    
    $('body').append('<div id="' + modalId + '" class="modal fade"></div>');
    
    $('#' + modalId).addClass("show").load(
        ROOTPATH + 'system/web/web.modal.php?flag=fixedloc_overtime' +
        '&device_id=' + getDeviceId() +
        '&check_time=' + fixedLoc.time +
        '&currlang=' + currLang
    );
    
    $("body").addClass("modal-open");
    
    $(document).on('click', '#' + modalId + ' .js_my_modal_close', function() {
        closeModal('#' + modalId);
        _fixedLocModalShown = false;
    });
}

/**
 * 觸發定點簽到Twilio通知
 * @param {Object} fixedLoc - 定點簽到信息
 */
function triggerFixedLocTwilio(fixedLoc) {
    $.ajax({
        type: 'POST',
        url: ROOTPATH + 'system/web/web.response.php',
        data: {
            Subject: "set_twilio_out",
            call_type: "miss_fixedloc",
            response_data: JSON.stringify({
                device_id: getDeviceId(),
                check_date: getCurrentDateString(),
                check_time: fixedLoc.time,
                location: fixedLoc.location || ''
            })
        },
        dataType: "json",
        success: function(response) {
            console.log('Twilio通知已觸發:', response);
        },
        error: function(error) {
            console.error('觸發Twilio通知失敗:', error);
        }
    });
}


// ==================== D2 定點簽到：簽到流程（NFC / 拍照） ====================

/**
 * 處理定點簽到點擊事件
 * @param {jQuery} element - 點擊元素
 */
function handleFixedLocSignin(element) {
    var currentTime = new Date();
    var nearFixedLoc = isNearFixedLocTime(currentTime);
    
    if (!nearFixedLoc) {
        showDelayMessage('暫時不需要簽到', 'warning');
        return;
    }
    
    checkIfAlreadySigned(nearFixedLoc).then(function(alreadySigned) {
        if (alreadySigned) {
            showDelayMessage('該定點時間已簽到', 'info');
            return;
        }
        
        showFixedLocCheckinModal(nearFixedLoc);
    });
}

/**
 * 顯示定點簽到確認modal
 * @param {Object} fixedLoc - 定點簽到信息
 */
function showFixedLocCheckinModal(fixedLoc) {
    var modalId = 'fixedloc_checkin_modal_' + makeid(8);
    
    $('body').append('<div id="' + modalId + '" class="modal fade"></div>');
    
    $('#' + modalId).addClass("show").load(
        ROOTPATH + 'system/web/web.modal.php?flag=fixedloc_checkin' +
        '&device_id=' + getDeviceId() +
        '&fixedloc_id=' + (fixedLoc.id || 0) +
        '&check_time=' + fixedLoc.time +
        '&location=' + (fixedLoc.location || '') +
        '&nfc_code=' + (fixedLoc.nfc_code || '') +
        '&nfc_serial=' + (fixedLoc.nfc_serial || '') +
        '&currlang=' + currLang
    );

    $("body").addClass("modal-open");

    $(document).on('click', '#' + modalId + ' .js_fixedloc_nfc', function() {
        var $button = $(this);
        var nfcOptions = {
            fixedloc_id: fixedLoc.id || 0,
            nfc_code: fixedLoc.nfc_code,
            nfc_serial: fixedLoc.nfc_serial,
            check_time: fixedLoc.time,
            location: fixedLoc.location || '',
            device_id: getDeviceId()
        };
        
        window._lastFixedLocInfo = fixedLoc;
        
        handleNFCScan($button, 'fixedloc', nfcOptions);
    });
    
    $(document).on('click', '#' + modalId + ' .js_fixedloc_photo', function() {
        startFixedLocPhotoSubmission(fixedLoc);
    });
    
    $(document).on('click', '#' + modalId + ' .js_my_modal_close', function() {
        closeModal('#' + modalId);
    });
}

/**
 * 依指定時段配置直接開啟定點簽到 modal（定點簽到獨立頁面點擊時段使用，不受鄰近時間限制）
 * @param {Object} cfg - { time, location, nfc_code, nfc_serial }
 */
function openFixedLocCheckin(cfg) {
    cfg = cfg || {};
    var fixedLoc = {
        id:         cfg.id || 0,
        time:       cfg.time || '',
        location:   cfg.location || '',
        nfc_code:   cfg.nfc_code || '',
        nfc_serial: cfg.nfc_serial || ''
    };
    // 定點簽到不綁定設備：未綁定設備也可簽到（記錄的 device_id 可為空，僅作追蹤）
    showFixedLocCheckinModal(fixedLoc);
    // 簽到成功後廣播事件，供頁面重新整理狀態
    $(document).one('fixedloc:done', function(){
        $(document).trigger('fixedloc:signed');
    });
}

/**
 * 開始定點簽到拍照流程
 * @param {Object} fixedLoc - 定點簽到信息
 */
function startFixedLocPhotoSubmission(fixedLoc) {
    window._pendingFixedLocData = {
        device_id: getDeviceId(),
        fixedloc_id: fixedLoc.id || 0,
        check_time: fixedLoc.time,
        location: fixedLoc.location || '',
        sign_type: 'photo'
    };
    
    $('.js_camera_snap_button[data-trigger="camera-fixedloc-checkin"]').trigger('click');
    
    $(document).one('change', '#camera-fixedloc-checkin', function(e) {});
}

/**
 * 處理定點簽到NFC數據
 * @param {string} nfc_read_code - NFC讀取的code
 * @param {string} serialNumber - NFC序列號
 * @param {Object} options - 選項參數
 * @param {jQuery} element - NFC按鈕元素
 */
function handleFixedLocNFC(nfc_read_code, serialNumber, options, element) {
    var localValidation = validateFixedLocNFCLocally(nfc_read_code, serialNumber, options);
    
    if (!localValidation.isValid) {
        showNFCConfirm(
            'fixedloc',
            function(retryOptions, el) {
                handleNFCScan(el, 'fixedloc', retryOptions);
            },
            options,
            element,
            localValidation.message || 'NFC卡驗證失敗，請使用正確的NFC卡或選擇拍照方式'
        );
        return;
    }
    
    $.ajax({
        type: 'POST',
        url: ROOTPATH + 'system/web/web.response.php',
        data: {
            Subject: "validate_fixedloc_nfc_card",
            nfc_read_code: nfc_read_code,
            nfc_read_serial: serialNumber,
            expected_nfc_code: options.nfc_code,
            expected_nfc_serial: options.nfc_serial,
            fixedloc_id: options.fixedloc_id || 0,   // 服務端以資料庫裡該點位的設定比對
            device_id: getDeviceId()
        },
        dataType: "json",
        success: function(response) {
            if (response.success && response.is_valid) {
                submitFixedLocSignin({
                    sign_type: 'nfc',
                    fixedloc_id: options.fixedloc_id || 0,
                    nfc_read_code: nfc_read_code,
                    nfc_read_serial: serialNumber,
                    device_id: getDeviceId(),
                    check_time: options.check_time,
                    location: options.location || ''
                }, element);
            } else {
                showNFCConfirm(
                    'fixedloc',
                    function(retryOptions, el) {
                        handleNFCScan(el, 'fixedloc', retryOptions);
                    },
                    options,
                    element,
                    'NFC卡驗證失敗，請使用正確的NFC卡或選擇拍照方式'
                );
            }
        },
        error: createAjaxErrorHandler(function() {
            showNFCConfirm(
                'fixedloc',
                function(retryOptions, el) {
                    handleNFCScan(el, 'fixedloc', retryOptions);
                },
                options,
                element,
                'NFC驗證失敗，請重試或選擇拍照方式'
            );
        })
    });
}

/**
 * 本地 NFC 校驗函數
 *
 * 驗證策略：**NDEF 內容（nfc_code）為主，serial 為輔**
 * - 有可用的 nfc_code → 本地放行，實際比對交由服務端（validate_fixedloc_nfc_card）。
 * - 沒有 nfc_code 才退回比對 serial（輔助識別）。
 * - 舊寫法在「serial 有設定但不相符」時直接判定失敗，沒有 fallback 到 nfc_code，
 *   與「serial 為輔」的原則相反，已修正。
 *
 * @param {string} nfc_read_code - NDEF 內容取出的代碼（主）
 * @param {string} serialNumber - NFC 標籤序號（輔）
 * @param {Object} options - 選項參數
 * @returns {Object} 校驗結果 {isValid, message, nfc_read_code}
 */
function validateFixedLocNFCLocally(nfc_read_code, serialNumber, options) {
    var result = {
        isValid: false,
        message: ''
    };
    
    var fixedLocConfig = getFixedLocConfigFromStorage();
    
    if (!fixedLocConfig || !fixedLocConfig.length) {
        result.message = '未找到定點簽到配置';
        return result;
    }
    
    var currentTime = new Date();
    var currentHour = currentTime.getHours();
    var currentMinute = currentTime.getMinutes();
    var currentTotalMinutes = currentHour * 60 + currentMinute;
    
    var targetConfig = null;
    
    for (var i = 0; i < fixedLocConfig.length; i++) {
        var config = fixedLocConfig[i];
        if (!config.time) continue;
        
        var timeParts = config.time.split(':');
        if (timeParts.length < 2) continue;
        
        var configHour = parseInt(timeParts[0], 10);
        var configMinute = parseInt(timeParts[1], 10);
        var configTotalMinutes = configHour * 60 + configMinute;
        
        var diffMinutes = currentTotalMinutes - configTotalMinutes;
        if (diffMinutes < -12 * 60) diffMinutes += 24 * 60;
        
        if (diffMinutes >= -3 && diffMinutes <= 5) {
            targetConfig = config;
            break;
        }
    }
    
    if (!targetConfig) {
        result.message = '當前時間不在定點簽到時間窗口內';
        return result;
    }
    
    // 【主】NDEF 內容（nfc_code）：本地放行，實際比對由服務端做
    if (targetConfig.nfc_code && nfc_read_code) {
        result.isValid = true;
        result.nfc_read_code = nfc_read_code;
        result.message = '將由服務端驗證 NFC code（主）';
        return result;
    }

    // 【輔】serial：僅在沒有可用 NDEF 內容時作為替代識別
    if (targetConfig.nfc_serial && serialNumber) {
        if (targetConfig.nfc_serial === serialNumber) {
            result.isValid = true;
            result.message = 'NFC serial 匹配成功（輔）';
        } else {
            result.isValid = false;
            result.message = 'NFC 驗證失敗，請使用正確的NFC卡或選擇拍照方式';
        }
        return result;
    }

    // 什麼都比對不了：若至少讀到 NDEF 內容，仍交由服務端判斷（可能 DB 用別的欄位設定）
    if (nfc_read_code) {
        result.isValid = true;
        result.nfc_read_code = nfc_read_code;
        result.message = '將由服務端驗證 NFC code';
        return result;
    }

    result.isValid = false;
    result.message = '未配置有效的 NFC 驗證信息';
    return result;
}

/**
 * 從 localStorage 獲取定點簽到配置
 * @returns {Object|null} 配置對象或null
 */
function getFixedLocConfigFromStorage() {
    return StorageUtil.get('fixedloc_config');
}

/**
 * 保存定點簽到配置到 localStorage
 * @param {Object} config - 配置對象
 * @returns {boolean} 是否成功
 */
function saveFixedLocConfigToStorage(config) {
    return StorageUtil.set('fixedloc_config', config);
}

/**
 * 提交定點簽到數據
 * @param {Object} signinData - 簽到數據
 * @param {jQuery} element - 元素（可選）
 */
function submitFixedLocSignin(signinData, element) {
    element = element || null;
    var postData = { Subject: "fixedloc_submit" };
    
    for (var key in signinData) {
        if (signinData.hasOwnProperty(key)) {
            postData[key] = signinData[key];
        }
    }
    // CSRF token 由 $.ajaxPrefilter 統一注入
    
    $.ajax({
        type: 'POST',
        url: ROOTPATH + 'system/web/web.response.php',
        data: postData,
        dataType: "json",
        beforeSend: function() {
            if (element) {
                element.addClass("clickdisabled");
            }
        },
        success: function(response) {
            if (element) {
                element.removeClass("clickdisabled");
            }
            
            if (response.success === "fixedloc_success") {
                if (typeof WebSocketManager !== 'undefined' && WebSocketManager.isConnected) {
                    WebSocketManager.send({
                        WS_Action: 'WS_FixedLocStatus',
                        data: {
                            action: 'fixedloc_signin_success',
                            device_id: signinData.device_id,
                            check_time: signinData.check_time,
                            location: signinData.location,
                            sign_type: signinData.sign_type,
                            timestamp: new Date().toISOString(),
                            nfc_read_code: signinData.nfc_read_code || null,
                            nfc_read_serial: signinData.nfc_read_serial || null
                        },
                        timestamp: new Date().getTime()
                    });
                    console.log('定點簽到通知已發送');
                }
                
                showDelayMessage('定點簽到成功', 'success', {
                    duration: 2000,
                    onDurationEnd: function() {
                        $(document).trigger('fixedloc:done');
                        $('.modal').remove();
                        $("body").removeClass("modal-open");
                        $("section").removeClass("alarmflash");
                        _fixedLocModalShown = false;
                        
                        if (_fixedLocTimeout) {
                            TimeoutManager.clear('fixedLocCheckin');
                            _fixedLocTimeout = null;
                        }
                    }
                });
            } else {
                showDelayMessage('簽到失敗: ' + (response.message || '未知錯誤'), 'error');
            }
        },
        error: createAjaxErrorHandler(function() {
            if (element) {
                element.removeClass("clickdisabled");
            }
            showDelayMessage('提交失敗，請檢查網絡連接', 'error');
        })
    });
}

/**
 * 處理定點簽到拍照上傳
 * @param {jQuery} fileInput - 文件輸入元素
 * @param {File} file - 文件對象
 * @param {string} subject - 主題
 */
function handleFixedLocCameraUpload(fileInput, file, subject) {
    if (!window._pendingFixedLocData) {
        console.error('沒有待提交的定點簽到數據');
        return;
    }
    
    // 打卡中提示（同 handleCameraUpload：從圖片壓縮就開始顯示，涵蓋全程）
    showGuardBusy(getGuardBusyText(subject || 'fixedloc'));

    compressImage(file).then(function(compressedBlob) {
        var formData = new FormData();
        var compressedFile = new File([compressedBlob], file.name, {
            type: 'image/jpeg',
            lastModified: Date.now()
        });
        
        formData.append('image', compressedFile);
        formData.append('Subject', subject);
        
        var data = window._pendingFixedLocData;
        formData.append('device_id', data.device_id);
        formData.append('fixedloc_id', data.fixedloc_id || 0);
        formData.append('check_time', data.check_time);
        formData.append('location', data.location || '');
        formData.append('sign_type', 'photo');
        // FormData 上傳無法透過 $.ajaxPrefilter 自動注入，需手動附加 CSRF token
        if (typeof CSRF_TOKEN !== 'undefined' && CSRF_TOKEN) {
            formData.append('_csrf_token', CSRF_TOKEN);
        }
        
        $.ajax({
            url: ROOTPATH + "system/web/web.response.php",
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            cache: false,
            success: function(responseData) {
                hideGuardBusy();
                handleFixedLocCameraResponse(responseData);
            },
            error: function() {
                console.error('上傳失敗');
                hideGuardBusy();
                showDelayMessage('拍照上傳失敗', 'error');
            }
        });
    }).catch(function(error) {
        console.error('圖片壓縮失敗:', error);
        hideGuardBusy();
        showDelayMessage('圖片處理失敗，請重新拍照', 'error');
    });
    
    fileInput.val('');
}

/**
 * 處理定點簽到拍照響應
 * @param {Object} data - 響應數據
 */
function handleFixedLocCameraResponse(data) {
    var response = typeof data === 'string' ? JSON.parse(data) : data;
    
    if (response.success === "fixedloc_success") {
        if (window._pendingFixedLocData) {
            if (typeof WebSocketManager !== 'undefined' && WebSocketManager.isConnected) {
                WebSocketManager.send({
                    WS_Action: 'WS_FixedLocStatus',
                    data: {
                        action: 'fixedloc_signin_success',
                        device_id: window._pendingFixedLocData.device_id,
                        check_time: window._pendingFixedLocData.check_time,
                        location: window._pendingFixedLocData.location || '',
                        sign_type: 'photo',
                        timestamp: new Date().toISOString(),
                        photo_submitted: true
                    },
                    timestamp: new Date().getTime()
                });
                console.log('定點簽到拍照通知已發送');
            }
        }
        
        showDelayMessage('定點簽到成功 (拍照)', 'success', {
            duration: 2000,
            onDurationEnd: function() {
                $(document).trigger('fixedloc:signed');   // 簽到頁刷新時段狀態
                $('.modal').remove();
                $("body").removeClass("modal-open");
                $("section").removeClass("alarmflash");
                delete window._pendingFixedLocData;
                _fixedLocModalShown = false;
                
                if (_fixedLocTimeout) {
                    TimeoutManager.clear('fixedLocCheckin');
                    _fixedLocTimeout = null;
                }
            }
        });
    } else {
        showDelayMessage('簽到失敗: ' + (response.message || '未知錯誤'), 'error');
    }
}



// ##########################################################################
// 【E】巡邏
//   guard/patrol.php：人臉登入後開始巡邏，逐點以 NFC 嘟卡（或拍照）簽到。
//   服務端：system/web/web.response.php 的 patrol_checkin / patrol_photo / patrol_pause / patrol_delay。
// ##########################################################################

// ==================== E1 巡邏頁初始化 ====================

/**
 * 初始化巡邏系統
 */
function initPatrolSystem() {
    if ($('#ps-left').length > 0 && $("input[name=limit_time]").val() > '0') {
        set_count_down($("input[name=limit_time]").val());
    }
    scrollPatrolToActive();
}

/**
 * 將當前應簽到的巡邏點（.patrol-location.activing）滾動到列表中央，
 * 避免每次簽到後（頁面 reload）下一點落在可視區外，需手動滾動。
 */
function scrollPatrolToActive() {
    var $container = $('.patrol-locations');
    var $active = $container.find('.patrol-location.activing').first();
    if (!$container.length || !$active.length) return;

    // 等 layout 穩定後再滾動（讓瀏覽器先完成 render）
    setTimeout(function() {
        var containerTop = $container.offset().top;
        var containerH = $container.height();
        var activeTop = $active.offset().top;
        var activeH = $active.outerHeight(true);
        var scrollTo = activeTop - containerTop - (containerH - activeH) / 2;
        var maxScroll = $container[0].scrollHeight - containerH;
        $container.scrollTop(Math.max(0, Math.min(scrollTo, maxScroll)));
    }, 0);
}


// ==================== E2 巡邏處理：打卡結果回饋、NFC 嘟卡 ====================

/**
 * 處理巡邏相機響應
 * @param {Object} data - 響應數據
 */
function handlePatrolCameraResponse(data) {
    if (data.error === "login_guard_success") {
        window.location.href = ROOTPATH + "guard";
    } else if (data.error === "patrol_success") {
        handlePatrolSuccessResponse();
    } else if (data.error === "patrol_complete") {
        handlePatrolCompleteResponse(data);
    } else if (data.error) {
        showPatrolFeedback('error', '巡邏處理失敗：' + data.error);
    }
}

/**
 * 巡邏打卡成功處理
 */
/**
 * 巡邏靜默掃描：提示後短暫延遲再繼續掃描（保持「隨時可嘟卡」狀態）
 */
function resumePatrolScan(element, options) {
    TimeoutManager.clear('nfcCooldown');
    _nfcScanning = false;
    TimeoutManager.set('nfcResume', function() {
        handleNFCScan(element, 'patrol', options);
    }, 800);
}

/**
 * 巡邏打卡結果回饋：畫面中央的大提示 + 音效（成功 yes.mp3／失敗 no.mp3）
 * 成功與失敗用同樣的大尺寸，成功略大；音效播放失敗（瀏覽器限制）時靜默忽略。
 * @param {string} type 'success' | 'error' | 'info'
 * @param {string} msg 提示文字
 * @param {Object} [opts] { duration, onDurationEnd }
 */
var _patrolFeedbackTimer = null;
function showPatrolFeedback(type, msg, opts) {
    opts = opts || {};
    var isOk = (type === 'success');
    try {
        var snd = new Audio(ROOTPATH + 'static/images/' + (isOk ? 'yes.mp3' : 'no.mp3'));
        var p = snd.play();
        if (p && p.catch) p.catch(function() {});
    } catch (e) { /* 音效失敗不影響流程 */ }

    var old = document.getElementById('patrol-feedback');
    if (old && old.parentNode) old.parentNode.removeChild(old);
    clearTimeout(_patrolFeedbackTimer);

    var bg = isOk ? '#52c41a' : (type === 'info' ? '#1677ff' : '#ff4d4f');
    var icon = isOk ? '✔' : (type === 'info' ? 'ℹ' : '✖');
    var box = document.createElement('div');
    box.id = 'patrol-feedback';
    box.style.cssText = 'position:fixed;left:50%;top:50%;transform:translate(-50%,-50%);z-index:2147483647;' +
        'width:min(88vw,420px);box-sizing:border-box;padding:' + (isOk ? '40px 24px' : '32px 24px') + ';border-radius:20px;text-align:center;' +
        'color:#fff;background:' + bg + ';box-shadow:0 12px 40px rgba(0,0,0,.35);pointer-events:none;';
    var ic = document.createElement('div');
    ic.style.cssText = 'font-size:' + (isOk ? '72px' : '56px') + ';line-height:1;margin-bottom:12px;';
    ic.textContent = icon;
    var tx = document.createElement('div');
    tx.style.cssText = 'font-size:' + (isOk ? '32px' : '26px') + ';font-weight:700;line-height:1.4;word-break:break-word;';
    tx.textContent = msg;
    box.appendChild(ic);
    box.appendChild(tx);
    document.body.appendChild(box);

    _patrolFeedbackTimer = setTimeout(function() {
        if (box.parentNode) box.parentNode.removeChild(box);
        if (typeof opts.onDurationEnd === 'function') opts.onDurationEnd();
    }, opts.duration || (isOk ? 2000 : 2500));
}

function handlePatrolSuccessResponse() {
    // 先停止掃描，避免 reload 前的重複讀卡送出第二次請求
    resetNFCState(null);
    showPatrolFeedback('success', '打卡成功', {
        duration: 2000,
        onDurationEnd: function() {
            window.location.reload();
        }
    });
}

/**
 * 巡邏完成處理
 * @param {Object} data - 響應數據
 */
function handlePatrolCompleteResponse(data) {
    try { new Audio(ROOTPATH + 'static/images/yes.mp3').play().catch(function() {}); } catch (e) {}
    // 巡邏已完成，停止掃描
    resetNFCState(null);
    openMyModal(ROOTPATH + 'system/web/web.modal.php?flag=patrol_complete&usetime=' + encodeURIComponent(data.usetime) + '&patrol_code=' + encodeURIComponent(data.patrol_code || ''));
}

/**
 * 提交巡邏 NFC數據到後台
 * @param {string} nfc_read_code - NFC讀取的code
 * @param {string} serialNumber - NFC序列號
 * @param {Object} options - 選項參數
 * @param {jQuery} element - NFC按鈕元素
 */
function handlePatrolNFC(nfc_read_code, serialNumber, options, element) {
    $.ajax({
        type: 'POST',
        dataType: "json",
        url: ROOTPATH + 'system/web/web.response.php',
        data: {
            Subject: "patrol_checkin",
            patrolcode: options.patrolcode,
            nfc_read_code: nfc_read_code,
            nfc_read_serial: serialNumber
        },
        success: function(data) {
            element.removeClass("clickdisabled");
            
            switch(data.success) {
                case "serial_not_match":
                    // code 對但卡片序號不符 → 疑似偽造卡，明確警告
                    showPatrolFeedback('error', '卡片序號驗證失敗，此卡可能是偽造卡', { duration: 4000 });
                    resumePatrolScan(element, options);
                    break;
                case "nfc_code_not_match":
                    // 巡邏卡但非本路線的點 → 簡短提示後自動繼續掃描，不用彈窗打斷
                    showPatrolFeedback('error', '不是本路線的巡邏點卡，請按正確巡邏路線');
                    resumePatrolScan(element, options);
                    break;
                case "point_wrong_order":
                    // 本路線的巡邏卡，但不是當前該簽的點（順序不對）
                    showPatrolFeedback('error', '不是當前巡邏點，請按正確巡邏路線簽到');
                    resumePatrolScan(element, options);
                    break;
                case "point_already_signed":
                    // 嘟到已簽過的點
                    showPatrolFeedback('error', '此巡邏點已簽到，請前往下一個巡邏點');
                    resumePatrolScan(element, options);
                    break;
                case "point_not_configured":
                    // 當前點後端沒設定 NFC → 永遠無法嘟卡，明確提示改用拍照，並通知管理員
                    showPatrolFeedback('error', '此巡邏點未設定 NFC，請點「NFC 簽到」改用拍照簽到', { duration: 4000 });
                    resumePatrolScan(element, options);
                    break;
                case "patrol_failed":
                    try { new Audio(ROOTPATH + 'static/images/no.mp3').play().catch(function() {}); } catch (e) {}
                    showNFCConfirm(
                        'patrol',
                        function(retryOptions, el) {
                            handleNFCScan(el, 'patrol', retryOptions);
                        },
                        options,
                        element,
                        '打卡失敗，請重試或選擇其他方式'
                    );
                    break;
                case "patrol_success":
                    handlePatrolSuccessResponse();
                    break;
                case "patrol_complete":
                    handlePatrolCompleteResponse(data);
                    break;
            }
        },
        error: createAjaxErrorHandler(function() {
            element.removeClass("clickdisabled");
            
            showNFCConfirm(
                'patrol',
                function(retryOptions, el) {
                    handleNFCScan(el, 'patrol', retryOptions);
                },
                options,
                element,
                '網絡錯誤，請重試或選擇其他方式'
            );
        })
    });
}



// ##########################################################################
// 【F】門禁 / 考勤 / 相機頁初始化
//   考勤（guard/attendance.php）、門禁、快速通行、安全相機頁的相機初始化與地點權限。
//   相機核心在 static/lib/camera/*.js；拍照 / 人臉辨識服務端為 system/web/camera.response.php。
// ##########################################################################
// ==================== F1 地點權限、考勤 / 門禁 / 快速通行 / 安全相機初始化 ====================

/**
 * 獲取地點權限
 * @returns {Array} 地點ID數組
 */
function getAllowLocation() {
    var allowLocationStr = readAllowSetting('allow_location');
    if (!allowLocationStr) return [];
    
    // 相容兩種格式（過渡期）：
    //   新格式（id）  ："5,8"           → [5, 8]（數字）
    //   舊格式（名稱）："總部大堂,分部A" → ["總部大堂", "分部A"]（字串）
    //
    // 背景：後台 tbl_device.allow_location 原本以「地點名稱」存入
    // （admin.menu.inc 的 getSettingForForeign 以名稱為選項值），
    // 但這裡原本一律 parseInt()，名稱轉數字得到 NaN 後被 filter 掉，
    // 導致永遠比對不到、地點按鈕全不出現。
    // 2026-09-04 起後台改存 id，此處同步改為同時支援兩者。
    return allowLocationStr.split(',')
        .map(function(item) { return item.trim(); })
        .filter(function(item) { return item !== ''; })
        .map(function(item) {
            var num = parseInt(item, 10);
            // 只有「整個字串都是數字」才視為 id，
            // 避免 "5號樓" 這類名稱被誤判成數字 5
            return (!isNaN(num) && String(num) === item) ? num : item;
        });
}

/**
 * 根據地點控制菜單顯示
 */
function applyAttendancePermissions() {
    var allowedLocations = getAllowLocation();
    
    console.log('允許的地點權限:', allowedLocations);
    
    if (allowedLocations.length === 0) {
        return;
    }
    
    $('.js_attendance_select').each(function() {
        var $this   = $(this);
        var locId   = $this.data('id');        // tbl_setting.id（新格式比對用）
        var locName = $this.data('location');  // 地點名稱（舊格式比對用）
        
        var isAllowed = allowedLocations.some(function(allowed) {
            if (typeof allowed === 'number') {
                return Number(locId) === allowed;   // 新格式：比對 id
            }
            return locName === allowed;             // 舊格式：比對名稱
        });
        
        if (isAllowed) {
            $this.removeClass('ishidden');
        } else {
            $this.addClass('ishidden');
        }
    });
    
    if ($('.js_attendance_select:not(.ishidden)').length === 0) {
        $.alert("沒有權限，重置設備編號", function() {
            clearDeviceId();
            window.location.href = ROOTPATH + 'guard';
        });
    }
}

/**
 * 初始化快速通行系統
 */
function initFastPassSystem() {
    cameraSwitchApply("realtime_detect", "defaultfront");
    $("#camera-container").addClass("activing");
}

/**
 * 初始化考勤相機
 */
function initAttendanceCamera() {
    var deviceId = getDeviceId();
    
    applyAttendancePermissions();
    
    cameraSwitchApply(
        "snap_photo",
        "defaultfront",
        "",
        {
            showToggleBtn: false,
            showCloseBtn: true,
            closeBtnClass: 'js_guard_logout',
        }
    );
    
    $("#camera-container").addClass("activing");
}

/**
 * 初始化門禁相機
 */
function initAccessCamera() {
    cameraSwitchApply("realtime_detect", "defaultback");
    cameraSwitchApply(
        "realtime_detect",
        "defaultfront",
        "",
        {
            showGuide: false,
            showTip: false,
            realtimeMode: true
        }
    );
    
    $("#camera-container").addClass("activing");
    
    setTimeout(function() {
        if (typeof cameraConfig !== 'undefined') {
            cameraConfig._REAL_DETECT = true;
            cameraConfig._FACE_DETECT = true;
            console.log("考勤頁面：實時人臉檢測已啟用");
        }
    }, 1000);
}

/**
 * 初始化安全相機
 */
function initSafetyCamera() {
    cameraSwitchApply("realtime_detect", "defaultback");
    $("#camera-container").addClass("activing");
}



// ##########################################################################
// 【G】警報與通知
//   倒計時、WebSocket 狀態通知（監控大屏用）、警報聲與逾期彈窗。
// ##########################################################################

// ==================== G1 倒計時 ====================

/**
 * 停止倒計時
 */
function stop_countdown() {
    if (countdownTimer) {
        clearInterval(countdownTimer);
        countdownTimer = null;
    }
    $('#ps-left').text('暫停計時').removeClass('timealarm');
}

/**
 * 設置倒計時
 * @param {number} _countdown - 倒計時秒數
 */
function set_count_down(_countdown) {
    if (_countdown === '' || _countdown === undefined) {
        _countdown = 60 * 1.5;
    }

    var $timer = $('#ps-left');
    $timer.text(fmtMSS(_countdown)).removeClass('timealarm');

    if (_countdown == 0) {
        return false;
    }

    countdownTimer = setInterval(function() {
        $timer.text(fmtMSS(_countdown));

        if (_countdown < 30 && _countdown >= 1) {
            $timer.addClass('timealarm');
        }

        if (_countdown == 1) {
            $timer.text('00:00').addClass('timealarm');
            console.log("未在規定時間內打卡");

            clearInterval(countdownTimer);
            countdownTimer = null;
            add_patrol_alarm();

            var curr_patrol_id = $("input[name=curr_id]").val();
            notifyPatrolTimeout(curr_patrol_id);
        }

        if (_countdown <= 0) {
            clearInterval(countdownTimer);
            countdownTimer = null;
            return false;
        }

        _countdown--;
    }, 1000);
}


// ==================== G2 WebSocket 通知（巡邏 / 簽到狀態推送給監控端） ====================

/**
 * 發送巡邏狀態更新通知到後端
 * @param {Object} updateData - 更新數據
 */
function notifyPatrolStatus(updateData) {
    $.ajax({
        type: 'POST',
        url: ROOTPATH + 'system/web/web.response.php',
        data: {
            Subject: "notify_patrol_status",
            updateData: JSON.stringify(updateData)
        },
        dataType: "json",
        success: function(data) {
            console.log('巡邏狀態通知已發送:', data);
        },
        error: function(error) {
            console.error('發送通知失敗:', error);
        }
    });
}

/**
 * 發送巡邏超時警報通知
 * @param {string} curr_patrol_id - 巡邏ID
 */
function notifyPatrolTimeout(curr_patrol_id) {
    var updateData = {
        id: curr_patrol_id,
        action: 'timeout_alarm',
        status: '超時未打卡',
        alarm_type: 'countdown_timeout',
        timestamp: new Date().toISOString(),
        limit_time: $("input[name=limit_time]").val() || '',
        current_time: Math.floor(Date.now() / 1000)
    };
    
    notifyPatrolStatus(updateData);
}

/**
 * 發送定點簽到狀態通知到監控端
 * @param {Object} data - 簽到數據
 */
function sendFixedLocStatusNotification(data) {
    try {
        if (typeof WebSocketManager !== 'undefined' && WebSocketManager.isConnected) {
            WebSocketManager.send({
                WS_Action: 'WS_FixedLocStatus',
                data: data,
                timestamp: new Date().getTime()
            });
            console.log('定點簽到通知已發送到監控端:', data);
        } else {
            $.ajax({
                type: 'POST',
                url: ROOTPATH + 'system/web/web.response.php',
                data: {
                    Subject: "notify_fixedloc_status",
                    notification_data: JSON.stringify(data)
                },
                dataType: "json",
                success: function(response) {
                    console.log('定點簽到通知已通過AJAX發送:', response);
                },
                error: function(error) {
                    console.error('發送定點簽到通知失敗:', error);
                }
            });
        }
    } catch (error) {
        console.error('發送WebSocket通知失敗:', error);
    }
}


// ==================== G3 警報聲與逾期彈窗 ====================

/**
 * 清除巡邏提醒
 */
function clear_patrol_remind() {
    $(".js_callsafe").removeClass("remindflash");
    _remindalarm = false;
}

/**
 * 添加巡邏提醒
 */
function add_patrol_remind() {
    $(".js_callsafe").addClass("remindflash");
    _remindalarm = true;
}

/**
 * 清除巡邏警報
 */
function clear_patrol_alarm() {
    if (!_patrolalarm) {
        return false;
    }
    
    $("section").removeClass("alarmflash");
    
    if (typeof _audio !== "undefined") {
        _audio.pause();
    }
    
    if ($(".js_callsafe_delay").length > 0) {
        $(".js_callsafe_delay").addClass("ishidden");
    }
    
    if ($(".js_callsafe").length > 0) {
        $(".js_callsafe").removeClass("ishidden");
    }
    
    _patrolalarm = false;
    resetOvertimeModalFlag('patrol');
    clearReminderTask('patrol');
    StorageUtil.remove('patrol_alarm');
}

/**
 * 添加報更警報（逾期聲響）
 */
function add_callsafe_alarm() {
    if (_callsafealarm) {
        return false;
    }

    var curr_callsafe_id = getDeviceId();

    // 第三層：只在首頁 / 報更頁彈阻塞式 modal，且只彈一次，之後改用 toast
    notifyOvertime('callsafe', curr_callsafe_id, '報更逾期，請盡快處理');

    $("section").addClass("alarmflash");

    _callsafeAudio = new Audio(ROOTPATH + "static/images/alarm02.wav");
    _callsafeAudio.loop = true;
    _callsafeAudio.play();

    _callsafealarm = true;

    StorageUtil.set('callsafe_alarm', {
        text: '報更逾期，請盡快處理',
        time: new Date().toISOString()
    });
    setReminderTask('callsafe', {
        active: true, level: 'danger',
        text: '報更逾期，請盡快處理'
    });
}

/**
 * 清除報更警報
 */
function clear_callsafe_alarm() {
    if (!_callsafealarm) {
        return false;
    }

    $("section").removeClass("alarmflash");

    if (typeof _callsafeAudio !== "undefined" && _callsafeAudio) {
        _callsafeAudio.pause();
    }

    _callsafeModalShown = false;
    _callsafealarm = false;
    resetOvertimeModalFlag('callsafe');
    clearReminderTask('callsafe');
    StorageUtil.remove('callsafe_alarm');
}

/**
 * 添加巡邏警報
 */
function add_patrol_alarm() {
    if (_patrolalarm) {
        return false;
    }
    // 當前點是可跳過巡邏點：逾時不響鬧（保安可跳過或直接到下一點拍卡）
    if ($("input[name='curr_optional']").val() === '1') {
        return false;
    }
    
    var curr_patrol_id = $("input[name='curr_id']").val();
    console.log("curr_patrol_id:", curr_patrol_id);
    
    // 第三層：只在首頁 / 巡邏頁彈阻塞式 modal，且只彈一次，之後改用 toast
    notifyOvertime('patrol', curr_patrol_id, '巡邏逾期，請盡快處理');
    
    $("section").addClass("alarmflash");
    
    _audio = new Audio(ROOTPATH + "static/images/alarm02.wav");
    _audio.loop = true;
    _audio.play();
    
    if ($(".js_callsafe_delay").length > 0) {
        $(".js_callsafe_delay").removeClass("ishidden");
    }
    
    if ($(".js_callsafe").length > 0) {
        $(".js_callsafe").addClass("ishidden");
    }
    
    $(".patrol-normal-container").addClass("activing");
    
    _patrolalarm = true;

    // 跨頁同步：寫入 localStorage，使首頁提醒條也能顯示巡邏逾期
    StorageUtil.set('patrol_alarm', {
        text: '巡邏逾期，請盡快處理',
        time: new Date().toISOString()
    });
    setReminderTask('patrol', {
        active: true, level: 'danger',
        text: '巡邏逾期，請盡快處理'
    });
}

/**
 * 顯示巡邏或報更超時提醒 modal
 * @param {string} type - 類型：'patrol' 或 'callsafe'
 * @param {string} id - 對應的 ID
 */
function showOvertimeModal(type, id) {
    if (!['patrol', 'callsafe'].includes(type)) {
        console.error('Invalid type. Must be "patrol" or "callsafe"');
        return;
    }
    
    if (!id) {
        console.error('ID is required');
        return;
    }
    
    if (type === 'callsafe' && _callsafeModalShown) {
        console.log('報更超時 modal 已顯示，跳過重複顯示');
        return;
    }
    
    var modalMap = {
        patrol: {
            modalId: 'patrol_overtime_modal',
            flag: 'patrol_overtime',
            paramName: 'curr_patrol_id'
        },
        callsafe: {
            modalId: 'callsafe_overtime_modal',
            flag: 'callsafe_overtime',
            paramName: 'curr_callsafe_id'
        }
    };
    
    var config = modalMap[type];
    
    $('#' + config.modalId).remove();
    
    if (type === 'callsafe') {
        _callsafeModalShown = true;
    }
    
    $('body').append('<div id="' + config.modalId + '" class="modal fade"></div>');
    
    $('#' + config.modalId).addClass("show").load(
        ROOTPATH + 'system/web/web.modal.php?flag=' + config.flag + '&id=' + id,
        function() {
            $("body").addClass("modal-open");
            startModalCountdown();
        }
    );
}

/**
 * 開始 modal 內的15秒倒計時
 */
function startModalCountdown() {
    var countdownSeconds = 20;
    var isPatrolModal = $('#patrol_overtime_modal').length > 0;
    var isCallsafeModal = $('#callsafe_overtime_modal').length > 0;
    var modalCountdownTimer;
    
    var updateCountdown = function() {
        var currentModal = isPatrolModal ? $('#patrol_overtime_modal') : $('#callsafe_overtime_modal');
        var countdownElement = currentModal.find('.countdown-display');
        
        if (countdownElement.length > 0) {
            countdownElement.text(countdownSeconds + ' 秒');
        }
        
        if (countdownSeconds <= 0) {
            clearInterval(modalCountdownTimer);
            currentModal.remove();
            $("body").removeClass("modal-open");
        }
        
        countdownSeconds--;
    };
    
    updateCountdown();
    modalCountdownTimer = setInterval(updateCountdown, 1000);
    
    $(document).off('click', '.js_confirm_overtime').on('click', '.js_confirm_overtime', function() {
        var _id = $(this).data("id");
        var flag = isPatrolModal ? 'patrol_delay' : 'callsafe_delay';
        
        clearInterval(modalCountdownTimer);
        $('.modal').remove();
        $("body").removeClass("modal-open");
        
        if (isPatrolModal) {
            openMyModal({ href: ROOTPATH + 'system/web/web.modal.php?flag=' + flag + '&patrolid=' + _id });
        } else if (isCallsafeModal) {
            console.log('報更超時確認處理');
        }
    });
    
    $(document).off('click', '.js_my_modal_close').on('click', '.js_my_modal_close', function() {
        clearInterval(modalCountdownTimer);
        $('.modal').remove();
        $("body").removeClass("modal-open");
    });
}



// ##########################################################################
// 【H】統一事件綁定與其他處理
//   ⚠ 兩個 $(function) 內集中綁定各功能的按鈕事件（.js_xxx），綁定先後即執行先後，請勿拆散。
//   新增按鈕事件時，加在對應功能的區塊內用 $(document).on(...) 亦可。
// ##########################################################################

// ==================== H1 統一事件綁定（通知權限、設備重置、各功能按鈕） ====================

// 重置設備並重新載入頁面的輔助函數
function resetAndReload($element) {
    $element.data('clickCount', 0);
    $element.data('lastClickTime', 0);

    var deviceId = getDeviceId();
    // 先把當前設備的推送訂閱標記為失效（create_status = 0），
    // 重新輸入合法編號後會再寫入一筆新的訂閱，避免舊 endpoint 殘留。
    if (deviceId && window.PWAConfig) {
        $.ajax({
            type: 'POST',
            url: ROOTPATH + 'system/web/web.response.php',
            data: { Subject: 'reset_push_manager', device_id: deviceId },
            dataType: 'json'
        });
    }

    clearDeviceId();
    
    $element.addClass('resetting');
    setTimeout(function() {
        location.reload();
    }, 300);
}

/**
 * 通知權限按鈕點擊事件處理
 * 功能：處理用戶點擊「同意接收通知」按鈕後的完整流程
 * 支持：iOS Chrome、iOS Safari、Android Chrome、其他瀏覽器
 * 兼容：瀏覽器模式 + PWA 獨立模式（添加到主畫面後）
 */
$(function() {
    // 用戶點擊通知權限按鈕
    $('body').on('click', '.js_pwa_notice_permission', function() {
        console.log('通知權限按鈕被點擊');
        
        // ==================== 第一步：關閉可能存在的模態框 ====================
        // 獲取當前按鈕所在的模態框（如果有的話）
        var _thismodal = $(this).closest(".modal");
        if (_thismodal.length) {
            // 移除模態框 DOM 元素
            _thismodal.remove();
            
            // 如果沒有任何模態框顯示了，移除 body 上的 modal-open 類和內聯樣式
            // 這樣可以恢復頁面滾動，避免背景鎖定
            if (!$(".modal.show").length) {
                $("body").removeClass("modal-open").removeAttr("style");
            }
        }
        
        // ==================== 第二步：嘗試調用 PWAConfig 的方法 ====================
        // 檢查 PWAConfig 全域對象是否存在（由 config.26041001.js 提供）
        if (typeof window.PWAConfig !== 'undefined') {
            
            // 情況 A：存在 requestNotificationPermission 方法（主要方法）
            // 這個方法內部會處理：權限檢查、請求權限、顯示提示、訂閱推送等完整流程
            if (typeof window.PWAConfig.requestNotificationPermission === 'function') {
                window.PWAConfig.requestNotificationPermission();
            } 
            // 情況 B：存在 handleNotificationPermissionClick 方法（舊版兼容）
            // 某些舊版本可能使用這個方法名，作為備用方案
            else if (typeof window.PWAConfig.handleNotificationPermissionClick === 'function') {
                window.PWAConfig.handleNotificationPermissionClick();
            } 
            // 情況 C：PWAConfig 存在但沒有對應方法，使用備用方案
            else {
                // 備用方案：直接使用瀏覽器原生 Notification API
                if ('Notification' in window) {
                    var permission = Notification.permission;
                    
                    // 子情況 C1：用戶已經同意過通知權限
                    if (permission === 'granted') {
                        myMsg.success('您已同意接收通知');
                    } 
                    // 子情況 C2：用戶之前拒絕過通知權限
                    else if (permission === 'denied') {
                        myMsg.error('您已拒絕接收通知');
                    } 
                    // 子情況 C3：從未詢問過，請求權限
                    else {
                        Notification.requestPermission();
                    }
                } 
                // 子情況 C4：瀏覽器完全不支持 Notification API
                else {
                    myMsg.error('您的瀏覽器不支持通知功能');
                }
            }
        } 
        // ==================== 第三步：PWAConfig 不存在時的最終備用方案 ====================
        // 當 PWAConfig 完全未加載時使用（極少見情況）
        else if ('Notification' in window) {
            var permission = Notification.permission;
            
            if (permission === 'granted') {
                myMsg.success('您已同意接收通知');
            } else if (permission === 'denied') {
                myMsg.error('您已拒絕接收通知');
            } else {
                // 直接請求權限（沒有後續訂閱處理，功能較簡陋）
                Notification.requestPermission();
            }
        }
        // 如果連 Notification API 都不支持，則什麼都不做（靜默失敗）
    });
});

$(function() {   
    // ==================== 通用事件處理 ====================
     
    $(document).on('click', function(e) {
        if ($(e.target).closest(".js_menu_dropdown").length === 0) {
            $(".js_menu_dropdown").removeClass("activing");
        }
    });
    
    // ==================== 單獨綁定事件處理器 ====================
    
    $('body').on('click', '.js_test_push', function() {
        startPushProcess(0, '2025-12-29', 'title001', 'content001', '', '');
    });
    
    $('body').on('click', '.js_scroll_to_here', function() {
        var _object = $(this).data("object");
        scroll_to_here(_object);
    });
    
    $('body').on('click', '.js_webpage_menu', function() {
        $(this).toggleClass("active").siblings().removeClass("active");
    });
    
    $('body').on('click', '.js_menu_dropdown', function() {
        $('.js_menu_dropdown').not(this).removeClass("activing");
        $(this).toggleClass("activing");
    });
    
    // ── 隱藏功能：重設設備編號 ──────────────────────────────────────────
    // 先連點頁尾左下的設備編號（.js_device_badge）3 次，再連點頁尾 logo 3 次，才彈出「重新輸入設備編號」。
    // 兩段之間及每次點擊間隔不超過 1 秒；順序錯或停頓過久即重來。避免有人隨手連點就打開。
    // 彈窗出現後點空白處不會關閉，只能按「重置設備 / 取消」；彈窗開著時不再重複彈出。
    var _deviceResetSeq = { step: '', count: 0, last: 0, open: false };

    function deviceResetTap(target) {
        var s = _deviceResetSeq;
        var now = Date.now();
        if (s.open) return;
        if (now - s.last > 1000) {           // 停頓過久 → 重新開始
            s.step = ''; s.count = 0;
        }
        s.last = now;

        if (target === 'badge') {
            if (s.step !== 'badge') { s.step = 'badge'; s.count = 0; }
            s.count++;
            if (s.count > 3) { s.count = 1; }  // 點太多次：視為重新開始
            return;
        }
        // target === 'logo'：必須先完成 3 次 badge
        if (s.step === 'badge' && s.count === 3) {
            s.step = 'logo'; s.count = 0;
        }
        if (s.step !== 'logo') {
            s.step = ''; s.count = 0;
            return;
        }
        s.count++;
        if (s.count < 3) return;

        s.step = ''; s.count = 0; s.open = true;
        myMsg.confirm("重新輸入設備編號", { okText: '重置設備', cancelText: '取消', backdropClose: false }).then(function(ok) {
            s.open = false;
            if (ok === true) {
                resetAndReload($('.js_device_badge').first());
            }
        });
    }

    $('body').on('click', '.js_device_badge', function() { deviceResetTap('badge'); });
    $('body').on('click', '.guard-footer > img', function() { deviceResetTap('logo'); });
    
    $('body').on('click', '.js_camera_snap_button', function() {
        var _trigger = $(this).data("trigger");
        $('#' + _trigger).trigger("click");
    });
    
    $('body').on('click', '.js_patrol_start', function() {
        var $patrolline_id = $(this).data("patrollineid");
        // 一併記錄本次巡邏所用的設備（供監控大屏顯示 P01 等）
        var _deviceIdForPatrol = '';
        try { _deviceIdForPatrol = localStorage.getItem('deviceId') || ''; } catch (e) {}
        $.ajax({
            type: 'POST',
            dataType: "json",
            url: ROOTPATH + 'system/web/web.response.php',
            data: { Subject: "patrol_create", patrolline_id: $patrolline_id, device_id: _deviceIdForPatrol },
            success: function(data) {
                if (data.success) location.reload();
                else showDelayMessage((data && data.message) || '無法開始巡邏，請重試', 'error');
            },
            error: function() {
                showDelayMessage('無法開始巡邏，請檢查網絡或重新登入', 'error');
            }
        });
    });
    
    $('body').on('click', '.js_patrol_checkin_nfc', function() {
        var patrolcode = $(this).data("patrolcode");
        handleNFCScan($(this), 'patrol', { patrolcode: patrolcode });
    });
    
    $('body').on('click', '.js_attendance_select', function() {
        $(this).toggleClass("active btnselected").siblings().removeClass("active btnselected");
        var _location = $(this).attr("data-location");
        // 同時帶上地點 id（服務端以 id 驗證設備是否可在此地點打卡，比名稱比對可靠）
        $(".js_attendance").attr("data-location", _location).attr("data-id", $(this).attr("data-id") || "").removeClass("btndisable");
    });
    
    $('body').on('click', '.js_callsafe_nfc', function() {
        handleNFCScan($(this), 'callsafe');
    });
    
    $('body').on('change', '.js_camera_snap_callsafe', function(e) {
        handleCameraUpload($(this));
    });
    
    $('body').on('click', '.js_select_staff_item', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var $this = $(this);
        var userId = $this.data('userid');
        var userName = $this.data('name') || '';
        var $input = $this.closest('.staff-items').siblings('.js_staff_ids_input');

        if (!$input.length) {
            $input = $this.closest('.modal').find('.js_staff_ids_input').first();
        }

        if (!$input.length) {
            console.error('找不到對應的輸入框');
            return;
        }

        var currentIds = getStaffIdsFromInput($input);

        if ($this.hasClass('activing')) {
            $this.removeClass('activing');
            removeStaffId(currentIds, userId, $input);
        } else {
            $this.addClass('activing');
            addStaffId(currentIds, userId, userName, $input);
        }
    });
    
    $('body').on('keyup', ".js_staff_ids_input", function(e) {
        var $input = $(this);
        var inputValue = $input.val();
        
        console.log('輸入值:', inputValue, '按鍵:', e.key);
        
        if (e.key === ' ' || e.key === ',' || e.key === 'Enter') {
            e.preventDefault();
            
            var newValue = inputValue.trim();
            if (newValue.length > 0 && !newValue.endsWith('/')) {
                newValue += '/';
                $input.val(newValue);
            }
        }
        
        var $container = $input.siblings('.staff-items');
        if ($container.length) {
            updateStaffSelection($input, $container);
        }
    });
    
    $('body').on('click', '.js_callsafe_submit', function() {
        handleCallsafeSubmit($(this));
    });
    
    $('body').on('click', '.js_callsafe_photo_submit', function() {
        handleCallsafePhotoSubmit($(this));
    });
    
    $('body').on('click', '.js_callsafe_pre_submit', function() {
        handleCallsafePreSubmit($(this));
    });
    
    $('body').on('click', '.js_add_alarm', function() {
        console.log("js_add_alarm click");
        add_patrol_alarm();
    });
    
    $('body').on('click', '.js_clear_alarm', function() {
        clear_patrol_alarm();
    });
    
    $('body').on('change', '.js_camera_snap_login', function(e) {
        handleCameraUpload($(this));
    });
    
    $('body').on('change', '.js_camera_upload', function(e) {
        handleCameraUpload($(this));
    });
    
    $('body').on('click', '.js_guard_logout', function() {
        handleLogout();
    });
    
    $('body').on('click', '.js_re_fastpass', function() {
        $("form.fastpass-form").find('input:not([type=hidden]),textarea').val("");
        $("#camera-container").addClass("activing");
        $("#infos-container").removeClass("activing");
        $(".result-container").removeClass("ishidden");
    });
    
    $('body').on('click', '.js_form_submit', function() {
        var $btn = $(this);
        var formContext = getFormContext($btn);
        if (!formContext) return;
        if (!window.validateForm(formContext)) return;

        var submitData = formContext.$form.ghostsf_serialize();
        // callsafe_delay 需要 device_id（舊 submitForm 透過 beforeSubmit 注入）
        if (formContext.$form.find("input[name=Subject]").val() === "callsafe_delay") {
            submitData += (submitData ? '&' : '') + "device_id=" + encodeURIComponent(getDeviceId());
        }

        submitFormData(ROOTPATH + 'system/web/web.response.php', formContext, submitData);
    });
    
    // ==================== 特殊事件處理 ====================
    
    $('body').on('click', ".js_pause_reason_check .dropdown-item", function(e) {
        var _value = $(this).data("value");
        var $form = $(this).closest("form");
        if (_value == '3') {
            $form.find(".pause-reason-detail").addClass("active");
        } else {
            $form.find(".pause-reason-detail").removeClass("active");
        }
    });
    
    $('body').on('click', ".js_delay_reason_check .dropdown-item", function(e) {
        var _value = $(this).data("value");
        var $form = $(this).closest("form");
        if (_value == '3') {
            $form.find(".delay-reason-detail").addClass("active");
        } else {
            $form.find(".delay-reason-detail").removeClass("active");
        }
    });
    
    $('body').on('keyup', "input[name=search_keyword]", function(e) {
        if (e.keyCode === 13) {
            $(this).closest(".search-bar").find(".js_search").trigger('click');
        }
    });
    
    $('body').on('change', '.js_camera_snap_patrol', function(e) {
        handleCameraUpload($(this));
    });
    
    $('input,textarea').bind('invalid', function(e) {
        var _thisalert = $(this).data("alert");
        if (typeof _thisalert !== "undefined") {
            e.target.setCustomValidity("");
            if (!e.target.validity.valid) {
                e.target.setCustomValidity(_thisalert);
            }
        }
    }).bind('blur', function(e) {
        if (!e.target.checkValidity()) {}
    });
    
    $('body').on('click', '.js_fixedloc_signin', function(e) {
        window.location.href = ROOTPATH + 'guard/fixedloc.php';
    });
    
    $('body').on('change', '.js_camera_snap_fixedloc', function(e) {
        handleCameraUpload($(this));
    });
});


// ==================== H2 其他處理：拍照提交、登出、表單提交 ====================

/**
 * 開始拍照提交流程
 * @param {string} type - 類型：'patrol'、'callsafe'、'fixedloc'
 * @param {jQuery} element - 按鈕元素（可選）
 */
function startPhotoSubmission(type, element) {
    if (element) {
        element.removeClass("clickdisabled");
    }
    
    switch(type) {
        case "callsafe":
            if (!window._pendingCallsafeData) {
                console.error('沒有待提交的報更數據');
                return;
            }
            
            window._pendingCallsafeData.sign_type = 'photo';
            $('.js_camera_snap_button[data-trigger="camera-callsafe-checkin"]').trigger('click');
            $(document).one('change', '#camera-callsafe-checkin', function(e) {});
            break;
            
        case "patrol":
            // 注意：巡邏拍照的觸發元素是 data-trigger="camera-patrol-checkin"（見 guard/patrol.php），
            // 不能用 'patrol'，否則選不到元素、點擊「使用拍照方式」會完全沒反應。
            $(".js_camera_snap_button[data-trigger='camera-patrol-checkin']").trigger("click");
            break;
        
        case "fixedloc":
            // 含 fixedloc_id，才能把拍照簽到歸到正確的點位
            window._pendingFixedLocData = {
                device_id: getDeviceId(),
                fixedloc_id: (window._lastFixedLocInfo && window._lastFixedLocInfo.id) || 0,
                check_time: (window._lastFixedLocInfo && window._lastFixedLocInfo.time) || '',
                location: (window._lastFixedLocInfo && window._lastFixedLocInfo.location) || '',
                sign_type: 'photo'
            };

            // 優先用頁面層級的隱藏 file input：直接打開相機/相簿，無需經過 info modal
            var $pageInput = $('#camera-fixedloc-checkin').first();
            if ($pageInput.length) {
                $pageInput.click();
                $(document).one('change', '#camera-fixedloc-checkin', function(e) {});
                break;
            }

            // 備援：modal 內的拍照按鈕
            var $fixedSnap = $('.js_camera_snap_button[data-trigger="camera-fixedloc-checkin"]');
            if ($fixedSnap.length) {
                $fixedSnap.trigger('click');
                $(document).one('change', '#camera-fixedloc-checkin', function(e) {});
                break;
            }

            // 最後備援：開 modal 觸發
            if (typeof openFixedLocCheckin === 'function' && window._lastFixedLocInfo) {
                openFixedLocCheckin(window._lastFixedLocInfo);
                var _tries = 0;
                var _timer = setInterval(function() {
                    var $s = $('.js_camera_snap_button[data-trigger="camera-fixedloc-checkin"]');
                    if ($s.length) {
                        clearInterval(_timer);
                        $s.trigger('click');
                        $(document).one('change', '#camera-fixedloc-checkin', function(e) {});
                    } else if (++_tries > 25) {
                        clearInterval(_timer);
                        showDelayMessage('拍照功能載入失敗，請重試', 'error');
                    }
                }, 200);
            } else {
                showDelayMessage('無法啟動拍照，請重試', 'error');
            }
            break;
    }
}

/**
 * 處理登出
 */
function handleLogout() {
    $.ajax({
        type: 'POST',
        url: ROOTPATH + 'system/web/web.response.php',
        data: {
            Subject: "guard_logout"
        },
        dataType: "json",
        success: function(data) {
            window.location.href = data.login_page;
        }
    });
}

/**
 * 工作地點（地址）選擇：開 APP 先選地址，localStorage 記憶選擇
 */
$(function () {
    var $regionSel = $('#patrol-region-select');
    if (!$regionSel.length) return;
    var saved = localStorage.getItem('patrol_region') || '';
    if (saved) {
        $regionSel.val(saved);
    }
    $regionSel.on('change', function () {
        localStorage.setItem('patrol_region', $(this).val());
    });
});

/**
 * 處理表單提交
 * @param {jQuery} element - 提交按鈕元素
 */
function handleFormSubmit(element) {
    var _thisform = element.closest('form');
    var _gotoUrl = _thisform.data("href");
    var _affixdata = '';
    
    if (_thisform[0].reportValidity()) {
        if (_thisform.find("input[name=Subject]").val() == "callsafe_delay") {
            var deviceId = getDeviceId();
            _affixdata = "&device_id=" + deviceId;
        }
        
        $.ajax({
            type: 'POST',
            dataType: "json",
            url: '' + ROOTPATH + 'system/web/web.response.php',
            data: _thisform.find("input[data-post!='not'],textarea[data-post!='not'],select[data-post!='not']").serialize() + _affixdata,
            beforeSend: function() {
                element.addClass("clickdisabled");
            },
            success: function(data) {
                element.removeClass("clickdisabled");
                handleFormSubmitResponse(data, _gotoUrl);
            },
            complete: function() {}
        });
    } else {
        _thisform[0].reportValidity();
    }
}

/**
 * 處理表單提交響應
 * @param {Object} data - 響應數據
 * @param {string} _gotoUrl - 跳轉URL
 */
function handleFormSubmitResponse(data, _gotoUrl) {
    switch (data.success) {
        case "fastpass_success":
            $.alert("Login Success", function() {
                $("form.fastpass-form").find('input:not([type=hidden]),textarea').val("");
                $("#camera-container").addClass("activing");
                $("#infos-container").removeClass("activing");
                $(".result-container").removeClass("ishidden");
            });
            break;
        case "callsafe_success":
            closeMyModal();
            load_callsafe_time_html(getDeviceId());
            break;
        case "callsafe_failed":
            closeMyModal();
            break;
        case "patrol_delay_success":
            closeMyModal();
            $(".patrol-normal-container").addClass("activing");
            break;
        case "patrol_delay_failed":
            closeMyModal();
            break;
        case "patrol_pause_success":
            closeMyModal();
            $(".patrol-normal-container").addClass("activing");
            stop_countdown();
            clear_patrol_alarm();
            openMyModal({ href: ROOTPATH + 'system/web/web.modal.php?flag=patrol_pausing' });
            break;
        case "patrol_pause_failed":
            closeMyModal();
            break;
        case "loginsuccess":
            closeMyModal();
            handleLoginSuccessResponse(data);
            break;
        case "login_guard_success":
        case "login_attendance_success":
            window.location.href = _gotoUrl;
            break;
        default:
            $.alert(data.success, function() {});
            break;
    }
}

/**
 * submitFormData 全局成功回調（由static/lib/js/jquery.extend.js 的 submitFormData 呼叫）
 * 轉發到既有 handleFormSubmitResponse，並從 context 取得表單的 data-href 作為跳轉目標
 */
window.handleSubmitResponse = function(context, data) {
    handleFormSubmitResponse(data, context.$form.data("href"));
};
/**
 * submitFormData 全局失敗回調
 */
window.handleSubmitError = function(context, error) {
    console.error('表單提交失敗:', error);
    showDelayMessage('提交失敗，請檢查網絡連接', 'error');
    if (context && context.$submitBtn) context.$submitBtn.prop('disabled', false);
};

/**
 * 處理登錄成功響應
 * @param {Object} data - 響應數據
 */
function handleLoginSuccessResponse(data) {
    switch (data.logintype) {
        case "attendance":
            window.location.href = ROOTPATH + "guard/attendance.php";
            break;
        case "access":
            window.location.href = ROOTPATH + "guard/access.php";
            break;
        case "patrol":
            // 登入成功後重載 patrol.php，讓頁面帶著新的 staff session 重新判斷路線。
            // 舊寫法開 flag=select_patrol（getPatrolPopupHtml 用 .guard-func，會被權限邏輯隱藏），
            // 且不會重新整理頁面，session 不會生效。
            window.location.href = ROOTPATH + "guard/patrol.php";
            break;
        case "callsafe":
            window.location.href = ROOTPATH + "guard/callsafe.php";
            break;
    }
}



// ##########################################################################
// 【I】共用：相機上傳、NFC 讀卡
//   報更 / 簽到 / 巡邏共用的拍照上傳與 Web NFC 讀卡（Android Chrome 才支援 Web NFC）。
// ##########################################################################

// ==================== I1 統一相機上傳 ====================

/**
 * 打卡／上傳中的全頁忙碌遮罩
 *
 * 為什麼需要：過去「拍照打卡」在選完照片後，要經過圖片壓縮 → 上傳 → 後端處理，
 * 這段時間畫面完全沒有任何變化，使用者以為沒反應就繼續點擊其他按鈕
 * （可能造成重複提交或誤操作）。此遮罩在處理期間覆蓋全頁並擋下點擊。
 *
 * 用法：showGuardBusy('打卡中，請稍候…') → hideGuardBusy()
 * 同一時間只會有一層（重複呼叫會重用同一個節點並更新文字）。
 */
function showGuardBusy(text) {
    var $busy = $('#guard-busy');

    if ($busy.length === 0) {
        $busy = $('<div id="guard-busy" class="guard-busy">' +
                    '<div class="guard-busy-spinner"></div>' +
                    '<div class="guard-busy-text"></div>' +
                  '</div>');
        $('body').append($busy);
    }

    $busy.find('.guard-busy-text').text(text || '處理中，請稍候…');
    $busy.show();
}

/** 關閉忙碌遮罩（直接移除節點，避免殘留導致下次不再顯示） */
function hideGuardBusy() {
    $('#guard-busy').remove();
}

/** 依 Subject 決定忙碌提示文字，讓使用者知道正在進行哪個操作 */
function getGuardBusyText(subject) {
    if (!subject) return '處理中，請稍候…';
    if (subject.indexOf('patrol') !== -1)   return '打卡中，請稍候…';
    if (subject.indexOf('callsafe') !== -1) return '報更中，請稍候…';
    if (subject.indexOf('fixedloc') !== -1) return '定點簽到中，請稍候…';
    if (subject.indexOf('login') !== -1)    return '驗證中，請稍候…';
    return '處理中，請稍候…';
}

/**
 * 處理相機上傳
 * @param {jQuery} fileInput - 文件輸入元素
 */
function handleCameraUpload(fileInput) {
    var file = fileInput[0].files[0];
    if (!file) return;
    
    var subject = fileInput.data("subject");
    
    if (subject && subject.indexOf('fixedloc') !== -1) {
        handleFixedLocCameraUpload(fileInput, file, subject);
        return;
    }
    
    var config = {
        subject: subject,
        patrolid: fileInput.data("patrolid") || fileInput.data("patrolcode"),
        callsafe: fileInput.data("deviceid")
    };
    
    if (subject && subject.indexOf('callsafe') !== -1 && !window._pendingCallsafeData) {
        console.error('沒有待提交的報更數據');
        return;
    }
    
    // 打卡中提示：從「圖片壓縮」就開始顯示，涵蓋壓縮 + 上傳 + 後端處理全程。
    // 遮罩覆蓋全頁並擋下點擊，避免使用者以為沒反應而重複點擊其他按鈕。
    showGuardBusy(getGuardBusyText(subject));
    
    compressImage(file).then(function(compressedBlob) {
        var formData = new FormData();
        var compressedFile = new File([compressedBlob], file.name, {
            type: 'image/jpeg',
            lastModified: Date.now()
        });

        formData.append('image', compressedFile);
        formData.append('Subject', subject);

        // 舊版此處另以 toast 提示「報更中，請稍候…」並存到 window._callsafeUploadToast，
        // 現已由全頁忙碌遮罩（showGuardBusy）統一取代：遮罩同時涵蓋圖片壓縮階段，
        // 且能擋下重複點擊。window._callsafeUploadToast 的殘留清理程式碼保留（有 if 守衛）。

        if (config.patrolid) {
            formData.append('patrolid', config.patrolid);
        }
        if (config.callsafe) {
            formData.append('deviceid', config.callsafe);
            if (window._pendingCallsafeData) {
                var data = window._pendingCallsafeData;
                formData.append('calldatepoint', data.calldatepoint);
                formData.append('calltimepoint', data.calltimepoint);
                formData.append('userids', JSON.stringify(data.userids));
                formData.append('delay_reason', data.delayReason);
                formData.append('delay_remark', data.delayRemark);
                formData.append('report_status', data.status);
                formData.append('sign_type', 'photo');
            }
        }
        // FormData 上傳無法透過 $.ajaxPrefilter 自動注入，需手動附加 CSRF token
        if (typeof CSRF_TOKEN !== 'undefined' && CSRF_TOKEN) {
            formData.append('_csrf_token', CSRF_TOKEN);
        }
        
        // 報更拍照由 camera.response.php 處理（callsafe_photo case 在此）
        var uploadUrl = ROOTPATH + "system/web/web.response.php";
        if (subject && subject.indexOf('callsafe') !== -1) {
            uploadUrl = ROOTPATH + "system/web/camera.response.php";
        }
        
        $.ajax({
            url: uploadUrl,
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            cache: false,
            success: function(responseData) {
                hideGuardBusy();   // 先收遮罩，讓後續的結果提示／跳轉能被看到
                handleCameraResponse(responseData, subject);
            },
            error: function(xhr, status, error) {
                console.error('上傳失敗:', error);
                hideGuardBusy();
                $.alert('上傳失敗，請檢查網絡連接');
            }
        });
    }).catch(function(error) {
        // 舊版此處只有 console.error → 使用者只會看到畫面沒反應，
        // 不知道是圖片處理失敗（選錯格式／檔案過大）而以為卡住。
        console.error('圖片壓縮失敗:', error);
        hideGuardBusy();
        $.alert('圖片處理失敗，請重新拍照');
    });
    
    fileInput.val('');
}

/**
 * 處理相機響應（整合所有類型）
 * @param {Object} responseData - 響應數據
 * @param {string} subject - 主題
 */
function handleCameraResponse(responseData, subject) {
    var data = typeof responseData === 'string' ? JSON.parse(responseData) : responseData;
    
    if (subject && subject.indexOf('callsafe') !== -1) {
        handleCallsafeCameraResponse(data);
    } else if (subject && subject.indexOf('patrol') !== -1) {
        handlePatrolCameraResponse(data);
    } else if (subject && subject.indexOf('login') !== -1) {
        handleLoginCameraResponse(data);
    } else {
        console.log('相機操作完成:', data);
    }
}

/**
 * 處理登錄相機響應
 * @param {Object} data - 響應數據
 */
function handleLoginCameraResponse(data) {
    if (data.error === "login_guard_success") {
        handleLoginSuccessResponse(data);
    } else {
        $.alert('登錄失敗，請重試');
    }
}


// ==================== I2 統一 NFC 讀卡 ====================

/**
 * 將 NFC 標籤序號正規化為字串（十六進制大寫）
 *
 * 驗證策略：**NDEF 內容（nfc_code）為主，serial 為輔**。
 * - `NDEFReadingEvent.serialNumber` 是 W3C Web NFC 規範定義的屬性（MDN：
 *   "returns the serial number of the device, which is used for anti-collision
 *   and identification, or an empty string if no serial number is available"）。
 * - 規範中它是 DOMString，所以實務上多數直接拿到字串；此處仍防禦性處理
 *   DataView / ArrayBuffer / Uint8Array，避免型別不符時崩潰。
 * - 可能回傳空字串 ""（標籤無 serial 或 UA 不提供），此時必須 fallback 到 NDEF 內容，
 *   見 validateCallsafeNFCCard() / validateFixedLocNFCCard()。
 *
 * @param {string|DataView|ArrayBuffer|Uint8Array} serialNumber - 原始序號
 * @returns {string} 正規化後的字串；無法處理時回傳空字串
 */
function getSerialNumberHex(serialNumber) {
    if (!serialNumber) return '';

    // 規範中 serialNumber 是 DOMString，直接回傳
    if (typeof serialNumber === 'string') return serialNumber;

    var bytes = null;
    if (serialNumber instanceof DataView) {
        bytes = new Uint8Array(serialNumber.buffer, serialNumber.byteOffset, serialNumber.byteLength);
    } else if (serialNumber instanceof ArrayBuffer) {
        bytes = new Uint8Array(serialNumber);
    } else if (serialNumber instanceof Uint8Array || Array.isArray(serialNumber)) {
        bytes = serialNumber;
    } else {
        return String(serialNumber);
    }

    var hex = '';
    for (var i = 0; i < bytes.length; i++) {
        var b = bytes[i] & 0xff;
        hex += (b < 16 ? '0' : '') + b.toString(16);
    }
    return hex.toUpperCase();
}

/** 取巡邏卡 /patrol/<code> 的原始代碼（保留字母，如 z1011） */
function getPatrolCardCode(nfcData) {
    var m = String(nfcData || '').trim().match(/\/patrol\/([^\/?#]+)/i);
    if (!m) return getLastSegmentNumber(nfcData);
    try { return decodeURIComponent(m[1]).trim(); } catch (e) { return m[1].trim(); }
}
/**
 * 判定 NDEF 內容是否為巡邏點卡（卡片寫入 https://<host>/patrol/<code>）。
 * 用寬鬆路徑判定（不限 host）：避免日後換網域時，實體舊卡被誤判為非巡邏卡而永遠打不了卡。
 * @param {string} nfcData - NDEF 解碼後的內容
 * @returns {boolean}
 */
function isPatrolCardData(nfcData) {
    return /^https?:\/\/[^\/]+\/patrol\/[^\/?#]+/i.test(String(nfcData || '').trim());
}

/**
 * 靜默掃描異常後自動重啟（有限次數），超過次數提示改用「NFC 簽到」按鈕手動重啟
 */
function scheduleNFCRestart(element, nfcType, options) {
    if (_nfcRestartCount >= 3) {
        showDelayMessage('NFC 掃描已停止，請點擊「NFC 簽到」重新開始', 'error');
        return;
    }
    _nfcRestartCount++;
    TimeoutManager.set('nfcRestart', function() {
        handleNFCScan(element, nfcType, options);
    }, 3000);
}

/**
 * 統一的 NFC 處理入口
 * @param {jQuery} element - 觸發元素
 * @param {string} nfcType - NFC類型：'patrol'、'callsafe'、'fixedloc'
 * @param {Object} options - 選項參數
 */
function handleNFCScan(element, nfcType, options) {
    options = options || {};
    var silent = !!options.silent;      // 靜默模式：自動掃描，不彈等待窗、不出錯不彈 confirm

    if (_nfcScanning) {
        console.log('NFC 掃描已在進行中，跳過重複調用');
        return;
    }

    _nfcScanning = true;

    // 手動觸發（按鈕點擊）視為新的開始，重置重啟計數
    if (!silent) {
        _nfcRestartCount = 0;
        TimeoutManager.clear('nfcRestart');
    }
    
    if (!checkWebNFCAndShowError(nfcType, element, silent)) {
        _nfcScanning = false;
        return;
    }
    
    element.addClass("clickdisabled");
    closeNFCModals();
    
    if (silent) {
        // 自動掃描：只用 toast 提示，不打斷頁面操作
        showDelayMessage('請將手機靠近巡邏點卡進行簽到', 'info');
    } else {
        var modalId = openMyModal(ROOTPATH + 'system/web/web.modal.php?flag=nfc_waiting');
        $('#' + modalId).attr('data-nfc-modal', 'true');
    }
    
    try {
        var ndef = new NDEFReader();
        _nfcReader = ndef;
        
        var scanPromise = ndef.scan();
        
        // 靜默模式下 scan() 可能因「未經用戶手勢授權」被拒，靜靜失敗並提示改用按鈕
        if (silent && scanPromise && typeof scanPromise.catch === 'function') {
            scanPromise.catch(function(err) {
                console.warn('[NFC] 自動掃描啟動失敗（可能未授權）:', err);
                resetNFCState(element);
                showDelayMessage('請點擊「簽到打卡」開始簽到', 'info');
            });
        }
        
        ndef.onreading = function(event) {
            try {
                ndef.onreading = null;
                ndef.onerror = null;
            } catch (e) {}
            
            TimeoutManager.clear('nfcTimeout');
            
            var decoder = new TextDecoder();
            var nfcData = '';
            var serialNumber = '';
            
            // serial 為「輔」：NDEFReadingEvent.serialNumber 是規範屬性（可能為空字串）。
            // 包 try/catch 確保即使格式不符預期也不會中斷 NFC 流程，
            // 驗證主體是下面的 NDEF 內容（nfc_read_code）。
            if (event.serialNumber) {
                try {
                    serialNumber = getSerialNumberHex(event.serialNumber);
                } catch (e) {
                    console.warn('[NFC] 讀取 serial 失敗，改用 NDEF 內容驗證:', e);
                    serialNumber = '';
                }
            }
            
            // NDEF 內容為「主」
            try {
                for (var i = 0; i < event.message.records.length; i++) {
                    nfcData = decoder.decode(event.message.records[i].data);
                    break;
                }
            } catch (e) {
                console.warn('[NFC] 解析 NDEF 內容失敗:', e);
                nfcData = '';
            }
            
            // 巡邏卡直接取 /patrol/<code> 的原始代碼（含字母，如 z1011）；
            // getLastSegmentNumber 會把 "z1011" 縮成 "1011"，與 tbl_patrol.nfc_code 對不上而一直報「不是本路線的巡邏點卡」。
            var nfc_read_code = (nfcType === 'patrol') ? getPatrolCardCode(nfcData) : getLastSegmentNumber(nfcData);

            // 除錯用：手機可用 Chrome DevTools 遠端檢視實際讀到的內容
            console.log('[NFC] 類型=' + nfcType +
                        ', NDEF內容="' + nfcData + '"' +
                        ', nfc_code=' + nfc_read_code +
                        ', serial=' + (serialNumber || '(空)'));

            // 巡邏模式：只有「巡邏點卡」（NDEF 為 /patrol/<code> 的 URL）才送後端驗證。
            // 其他 NFC 設備（八達通/銀行卡多半不觸發 NDEF 讀取）、其他網址卡、空白卡 → 靜默忽略，繼續掃描
            if (nfcType === 'patrol' && !isPatrolCardData(nfcData)) {
                console.log('[NFC] 非巡邏點卡，忽略並繼續掃描:', nfcData || '(無 NDEF 內容)');
                _nfcScanning = false;
                TimeoutManager.clear('nfcCooldown');
                setTimeout(function() { handleNFCScan(element, nfcType, options); }, 300);
                return;
            }

            // 成功讀取視為掃描正常，重置重啟計數
            _nfcRestartCount = 0;

            // 兩者都讀不到 → 標籤無法辨識，直接提示，不要送空值給後端
            if (!nfc_read_code && !serialNumber) {
                console.error('[NFC] 無法從標籤讀取任何識別資訊');
                resetNFCState(element);
                if (silent) {
                    showDelayMessage('無法讀取標籤，請再嘟一次或點「NFC 簽到」', 'error');
                    setTimeout(function() { handleNFCScan(element, nfcType, options); }, 800);
                } else {
                    showNFCConfirm(
                        nfcType,
                        function(retryOptions, el) {
                            handleNFCScan(el, nfcType, retryOptions);
                        },
                        options,
                        element,
                        '無法讀取標籤內容，請重試或選擇拍照方式'
                    );
                }
                return;
            }
            
            switch(nfcType) {
                case 'patrol':
                    handlePatrolNFC(nfc_read_code, serialNumber, options, element);
                    break;
                case 'callsafe':
                    handleCallsafeNFC(nfc_read_code, serialNumber, element);
                    break;
                case 'fixedloc':
                    handleFixedLocNFC(nfc_read_code, serialNumber, options, element);
                    break;
                default:
                    console.error('未知的 NFC 類型:', nfcType);
                    resetNFCState(element);
                    break;
            }
            
            _nfcScanning = true;
            TimeoutManager.set('nfcCooldown', function() {
                _nfcScanning = false;
            }, 2000);
            
            closeNFCModals();
        };
        
        ndef.onerror = function(error) {
            console.error("NFC掃描錯誤:", error);
            if (silent) {
                resetNFCState(element);
                scheduleNFCRestart(element, nfcType, options);   // 自動重啟掃描，避免悄悄停掉
                return;
            }
            handleNFCError(nfcType, options, element, 'NFC掃描異常，請選擇操作方式');
        };

        if (!silent) {
            setupNFCTimeout(nfcType, options, element);
            setupPhotoButton(nfcType, options, element);
        }

    } catch (error) {
        console.error("NFC掃描異常:", error);
        if (silent) {
            resetNFCState(element);
            scheduleNFCRestart(element, nfcType, options);
            return;
        }
        handleNFCError(nfcType, options, element, 'NFC掃描異常，請選擇操作方式');
    }
}

/**
 * NFC 錯誤處理函數
 * @param {string} nfcType - NFC類型
 * @param {Object} options - 選項參數
 * @param {jQuery} element - 觸發元素
 * @param {string} message - 錯誤訊息
 */
function handleNFCError(nfcType, options, element, message) {
    TimeoutManager.clear('nfcTimeout');
    resetNFCState(element);
    
    showNFCConfirm(
        nfcType,
        function(retryOptions, el) {
            handleNFCScan(el, nfcType, retryOptions);
        },
        options,
        element,
        message
    );
}

/**
 * 重置 NFC 狀態
 * @param {jQuery} element - 觸發元素
 */
function resetNFCState(element) {
    _nfcScanning = false;
    TimeoutManager.clear('nfcTimeout');
    TimeoutManager.clear('nfcCooldown');
    
    if (_nfcReader) {
        try {
            _nfcReader.onreading = null;
            _nfcReader.onerror = null;
        } catch (e) {
            console.log("清理 NFC reader");
        }
        _nfcReader = null;
    }
    
    closeNFCModals();
    
    if (element) {
        element.removeClass("clickdisabled");
    }
}

/**
 * 關閉所有 NFC 相關的 modal
 */
function closeNFCModals() {
    TimeoutManager.clear('nfcTimeout');
    _nfcScanning = false;
    
    if (_nfcReader) {
        try {
            _nfcReader.onreading = null;
            _nfcReader.onerror = null;
        } catch (e) {
            console.log("清理 NFC reader");
        }
        _nfcReader = null;
    }
    
    $('.modal[data-nfc-modal="true"]').remove();
    
    $('.modal').each(function() {
        if ($(this).find('.warning-container').length > 0) {
            $(this).remove();
        }
    });
    
    if ($('.modal.show').length === 0) {
        $('body').removeClass('modal-open').removeAttr('style');
    }
}

/**
 * 設置 NFC 超時處理
 * @param {string} nfcType - NFC類型
 * @param {Object} options - 選項參數
 * @param {jQuery} element - 觸發元素
 */
function setupNFCTimeout(nfcType, options, element) {
    TimeoutManager.set('nfcTimeout', function() {
        handleNFCError(nfcType, options, element, 'NFC掃描超時，請重試或選擇其他方式');
    }, 30000);
}

/**
 * 設置拍照按鈕事件
 * @param {string} nfcType - NFC類型
 * @param {Object} options - 選項參數
 * @param {jQuery} element - 觸發元素
 */
function setupPhotoButton(nfcType, options, element) {
    $(document).off('click.nfc', '.js_use_photo_submit');
    
    $(document).on('click.nfc', '.js_use_photo_submit', function() {
        TimeoutManager.clear('nfcTimeout');
        resetNFCState(element);
        startPhotoSubmission(nfcType, element);
    });
}

/**
 * 顯示 NFC 失敗確認對話框
 * @param {string} type - 類型：'patrol'、'callsafe'、'fixedloc'
 * @param {Function} onRetry - 重試 NFC 的回調函數
 * @param {Object} retryOptions - 重試時的選項參數
 * @param {jQuery} element - NFC 按鈕元素
 * @param {string} message - 自定義提示消息（可選）
 */
function showNFCConfirm(type, onRetry, retryOptions, element, message) {
    if (window._nfcConfirmShown) {
        console.log('NFC 確認框已在顯示中，跳過重複彈出');
        return;
    }
    
    window._nfcConfirmShown = true;
    closeNFCModals();
    
    var defaultMessages = {
        patrol: '巡邏NFC掃描失敗，請選擇操作方式',
        callsafe: '報更NFC掃描失敗，請選擇操作方式',
        fixedloc: '定點簽到NFC掃描失敗，請選擇操作方式',
    };
    
    var title = 'NFC操作失敗';
    var messageContent = message || defaultMessages[type] || 'NFC操作失敗，請選擇操作方式';
    
    myMsg.confirm(title, {
        body: '<img src="' + ROOTPATH + 'static/lib/icons/cancel.webp" title="" alt="" />' +
              '<p>' + messageContent + '</p>',
        okText: '重新感應NFC',
        cancelText: '切換拍照'
    }).then(function(e) {
        window._nfcConfirmShown = false;

        if (e === true) {
            if (element) {
                element.removeClass("clickdisabled");
            }
            onRetry(retryOptions, element);
        } else {
            startPhotoSubmission(type, element);
        }
    });
}

/**
 * 從 URL 字串中提取最後一個斜槓後的數字
 * @param {string} url - 需要解析的完整 URL 字串
 * @returns {number|null} - 返回解析出的數字，如果解析失敗則返回 null
 */
function getLastSegmentNumber(url) {
    if (!url) return '';

    var trimmed = String(url).trim();
    if (!trimmed) return '';

    // 取最後一段（payload 可能是 URL，也可能是純文字）
    var segments  = trimmed.split('/');
    var lastSegment = segments[segments.length - 1].trim();
    if (!lastSegment) return '';

    // 主識別以「數字代碼」為主，優先取整段數字
    if (/^\d+$/.test(lastSegment)) {
        return lastSegment;
    }
    // 次選：擷取第一段連續數字（例如 "NFC-0042" → "0042"）
    var m = lastSegment.match(/\d+/);
    if (m) return m[0];
    // 最後：回傳原始字串，讓服務端比對文字型代碼
    return lastSegment;
}

/**
 * 檢查 Web NFC 支持並顯示錯誤
 * @param {string} type - 類型：'patrol'、'callsafe'、'fixedloc'
 * @param {jQuery} element - NFC 按鈕元素
 * @returns {boolean} 是否支持 NFC
 */
function checkWebNFCAndShowError(type, element, silent) {
    if (!("NDEFReader" in window)) {
        // 靜默模式（自動掃描）：不彈窗，由呼叫方自行處理
        if (silent) return false;
        myMsg.confirm('Web NFC不支持', {
            body: '<img src="' + ROOTPATH + 'static/lib/icons/confirm.webp" title="" alt="" />' +
                  '<p>您的設備不支持Web NFC功能，請使用拍照方式。</p>',
            okText: '使用拍照方式',
            cancelText: '取消'
        }).then(function(e) {
            if (e === true) {
                startPhotoSubmission(type, element);
            }
        });
        return false;
    }
    return true;
}
// ==================== 可跳過巡邏點：按「跳過此點」 ====================
// 當前點為可跳過巡邏點（後台巡邏點設定）時顯示；也可直接到下一點拍卡，伺服器會自動跳過。
// 斷網或仍有待上傳記錄時，由 js/web.patrol.offline.js 攔截改為手機上記錄。
$(document).on('click', '.js_patrol_skip', function(e) {
    e.preventDefault();
    var $btn = $(this);
    if ($btn.hasClass('clickdisabled')) return;
    var name = $("input[name='patrol_name']").val() || '此巡邏點';
    var ask = (window.myMsg && myMsg.confirm) ? myMsg.confirm('確定跳過「' + name + '」？', { okText: '跳過', cancelText: '取消' }) : Promise.resolve(true);
    ask.then(function(ok) {
        if (!ok) return;
        $btn.addClass('clickdisabled');
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: ROOTPATH + 'system/web/web.response.php',
            data: { Subject: 'patrol_skip', patrolcode: $btn.data('patrolcode'), patrol_id: $btn.data('patrolid') },
            success: function(data) {
                $btn.removeClass('clickdisabled');
                if (data.success === 'patrol_complete') {
                    handlePatrolCompleteResponse(data);
                } else if (data.success === 'patrol_success') {
                    resetNFCState(null);
                    showPatrolFeedback('success', '已跳過', { duration: 1500, onDurationEnd: function() { window.location.reload(); } });
                } else {
                    showPatrolFeedback('error', data.message || '無法跳過', { duration: 3000 });
                }
            },
            error: function(xhr) {
                $btn.removeClass('clickdisabled');
                showPatrolFeedback('error', '跳過失敗（' + (xhr.status || '網絡') + '），請重試', { duration: 3000 });
            }
        });
    });
});
